// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file memba/v1/memba.proto (package memba.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file memba/v1/memba.proto.
 */
export const file_memba_v1_memba: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * @generated from message memba.v1.Challenge
 */
export type Challenge = Message<"memba.v1.Challenge"> & {
  /**
   * @generated from field: bytes nonce = 1;
   */
  nonce: Uint8Array;

  /**
   * @generated from field: string expiration = 2;
   */
  expiration: string;

  /**
   * ed25519 signature by server (of protobuf encoding with this field zeroed)
   *
   * @generated from field: bytes server_signature = 3;
   */
  serverSignature: Uint8Array;

  /**
   * SHA256 of the pubkey this challenge is bound to (v6 AUTH-01 fix)
   *
   * @generated from field: string bound_pubkey_hash = 4;
   */
  boundPubkeyHash: string;

  /**
   * v7.1 AUTH-CHAINID-01: chain this challenge is bound to
   *
   * @generated from field: string chain_id = 5;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.Challenge.
 * Use `create(ChallengeSchema)` to create a new message.
 */
export const ChallengeSchema: GenMessage<Challenge> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 0);

/**
 * Token is the auth credential passed with authenticated requests.
 * We use string for nonce/signature because browser storage has poor bytes support.
 *
 * @generated from message memba.v1.Token
 */
export type Token = Message<"memba.v1.Token"> & {
  /**
   * base64-encoded
   *
   * @generated from field: string nonce = 1;
   */
  nonce: string;

  /**
   * @generated from field: string expiration = 2;
   */
  expiration: string;

  /**
   * @generated from field: string user_address = 3;
   */
  userAddress: string;

  /**
   * base64 ed25519 signature by server
   *
   * @generated from field: string server_signature = 4;
   */
  serverSignature: string;

  /**
   * v7.1 AUTH-CHAINID-01: chain this token is valid for
   *
   * @generated from field: string chain_id = 5;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.Token.
 * Use `create(TokenSchema)` to create a new message.
 */
export const TokenSchema: GenMessage<Token> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 1);

/**
 * @generated from message memba.v1.TokenRequestInfo
 */
export type TokenRequestInfo = Message<"memba.v1.TokenRequestInfo"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: memba.v1.Challenge challenge = 2;
   */
  challenge?: Challenge | undefined;

  /**
   * @generated from field: string user_bech32_prefix = 3;
   */
  userBech32Prefix: string;

  /**
   * Amino JSON pubkey — optional if user_address is set
   *
   * @generated from field: string user_pubkey_json = 4;
   */
  userPubkeyJson: string;

  /**
   * Direct address — used when pubkey unavailable from wallet
   *
   * @generated from field: string user_address = 5;
   */
  userAddress: string;

  /**
   * v7.1 AUTH-CHAINID-01: chain the client is authenticating for
   *
   * @generated from field: string chain_id = 6;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.TokenRequestInfo.
 * Use `create(TokenRequestInfoSchema)` to create a new message.
 */
export const TokenRequestInfoSchema: GenMessage<TokenRequestInfo> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 2);

/**
 * @generated from message memba.v1.GetChallengeRequest
 */
export type GetChallengeRequest = Message<"memba.v1.GetChallengeRequest"> & {
  /**
   * Amino JSON pubkey — binds the challenge to this key (v6 AUTH-01 fix)
   *
   * @generated from field: string user_pubkey_json = 1;
   */
  userPubkeyJson: string;

  /**
   * v7.1 AUTH-CHAINID-01: chain to bind the challenge to
   *
   * @generated from field: string chain_id = 2;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.GetChallengeRequest.
 * Use `create(GetChallengeRequestSchema)` to create a new message.
 */
export const GetChallengeRequestSchema: GenMessage<GetChallengeRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 3);

/**
 * @generated from message memba.v1.GetChallengeResponse
 */
export type GetChallengeResponse = Message<"memba.v1.GetChallengeResponse"> & {
  /**
   * @generated from field: memba.v1.Challenge challenge = 1;
   */
  challenge?: Challenge | undefined;
};

/**
 * Describes the message memba.v1.GetChallengeResponse.
 * Use `create(GetChallengeResponseSchema)` to create a new message.
 */
export const GetChallengeResponseSchema: GenMessage<GetChallengeResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 4);

/**
 * @generated from message memba.v1.GetTokenRequest
 */
export type GetTokenRequest = Message<"memba.v1.GetTokenRequest"> & {
  /**
   * protojson encoding of TokenRequestInfo
   *
   * @generated from field: string info_json = 1;
   */
  infoJson: string;

  /**
   * ed25519 signature by client of info_json
   *
   * @generated from field: string user_signature = 2;
   */
  userSignature: string;
};

/**
 * Describes the message memba.v1.GetTokenRequest.
 * Use `create(GetTokenRequestSchema)` to create a new message.
 */
export const GetTokenRequestSchema: GenMessage<GetTokenRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 5);

/**
 * @generated from message memba.v1.GetTokenResponse
 */
export type GetTokenResponse = Message<"memba.v1.GetTokenResponse"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;
};

/**
 * Describes the message memba.v1.GetTokenResponse.
 * Use `create(GetTokenResponseSchema)` to create a new message.
 */
export const GetTokenResponseSchema: GenMessage<GetTokenResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 6);

/**
 * @generated from message memba.v1.Multisig
 */
export type Multisig = Message<"memba.v1.Multisig"> & {
  /**
   * @generated from field: string created_at = 1;
   */
  createdAt: string;

  /**
   * @generated from field: string chain_id = 2;
   */
  chainId: string;

  /**
   * @generated from field: string address = 3;
   */
  address: string;

  /**
   * @generated from field: bool joined = 4;
   */
  joined: boolean;

  /**
   * @generated from field: string name = 5;
   */
  name: string;

  /**
   * @generated from field: string pubkey_json = 6;
   */
  pubkeyJson: string;

  /**
   * @generated from field: repeated string users_addresses = 7;
   */
  usersAddresses: string[];

  /**
   * @generated from field: uint32 threshold = 8;
   */
  threshold: number;

  /**
   * @generated from field: uint32 members_count = 9;
   */
  membersCount: number;
};

/**
 * Describes the message memba.v1.Multisig.
 * Use `create(MultisigSchema)` to create a new message.
 */
export const MultisigSchema: GenMessage<Multisig> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 7);

/**
 * @generated from message memba.v1.CreateOrJoinMultisigRequest
 */
export type CreateOrJoinMultisigRequest = Message<"memba.v1.CreateOrJoinMultisigRequest"> & {
  /**
   * @generated from field: string chain_id = 1;
   */
  chainId: string;

  /**
   * @generated from field: string multisig_pubkey_json = 2;
   */
  multisigPubkeyJson: string;

  /**
   * @generated from field: memba.v1.Token auth_token = 3;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string name = 4;
   */
  name: string;

  /**
   * @generated from field: string bech32_prefix = 5;
   */
  bech32Prefix: string;

  /**
   * Required for native identities; must match the independently derived address.
   *
   * @generated from field: string expected_multisig_address = 6;
   */
  expectedMultisigAddress: string;

  /**
   * New native creation sorts keys like gnokey; imports preserve exact order.
   *
   * @generated from field: bool native_create = 7;
   */
  nativeCreate: boolean;
};

/**
 * Describes the message memba.v1.CreateOrJoinMultisigRequest.
 * Use `create(CreateOrJoinMultisigRequestSchema)` to create a new message.
 */
export const CreateOrJoinMultisigRequestSchema: GenMessage<CreateOrJoinMultisigRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 8);

/**
 * @generated from message memba.v1.CreateOrJoinMultisigResponse
 */
export type CreateOrJoinMultisigResponse = Message<"memba.v1.CreateOrJoinMultisigResponse"> & {
  /**
   * @generated from field: bool created = 1;
   */
  created: boolean;

  /**
   * @generated from field: bool joined = 2;
   */
  joined: boolean;

  /**
   * @generated from field: string multisig_address = 3;
   */
  multisigAddress: string;
};

/**
 * Describes the message memba.v1.CreateOrJoinMultisigResponse.
 * Use `create(CreateOrJoinMultisigResponseSchema)` to create a new message.
 */
export const CreateOrJoinMultisigResponseSchema: GenMessage<CreateOrJoinMultisigResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 9);

/**
 * @generated from message memba.v1.MultisigInfoRequest
 */
export type MultisigInfoRequest = Message<"memba.v1.MultisigInfoRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string multisig_address = 2;
   */
  multisigAddress: string;

  /**
   * @generated from field: string chain_id = 3;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.MultisigInfoRequest.
 * Use `create(MultisigInfoRequestSchema)` to create a new message.
 */
export const MultisigInfoRequestSchema: GenMessage<MultisigInfoRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 10);

/**
 * @generated from message memba.v1.MultisigInfoResponse
 */
export type MultisigInfoResponse = Message<"memba.v1.MultisigInfoResponse"> & {
  /**
   * @generated from field: memba.v1.Multisig multisig = 1;
   */
  multisig?: Multisig | undefined;
};

/**
 * Describes the message memba.v1.MultisigInfoResponse.
 * Use `create(MultisigInfoResponseSchema)` to create a new message.
 */
export const MultisigInfoResponseSchema: GenMessage<MultisigInfoResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 11);

/**
 * @generated from message memba.v1.MultisigsRequest
 */
export type MultisigsRequest = Message<"memba.v1.MultisigsRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string start_after = 3;
   */
  startAfter: string;

  /**
   * @generated from field: string chain_id = 4;
   */
  chainId: string;

  /**
   * @generated from field: memba.v1.JoinState join_state = 5;
   */
  joinState: JoinState;
};

/**
 * Describes the message memba.v1.MultisigsRequest.
 * Use `create(MultisigsRequestSchema)` to create a new message.
 */
export const MultisigsRequestSchema: GenMessage<MultisigsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 12);

/**
 * @generated from message memba.v1.MultisigsResponse
 */
export type MultisigsResponse = Message<"memba.v1.MultisigsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.Multisig multisigs = 1;
   */
  multisigs: Multisig[];
};

/**
 * Describes the message memba.v1.MultisigsResponse.
 * Use `create(MultisigsResponseSchema)` to create a new message.
 */
export const MultisigsResponseSchema: GenMessage<MultisigsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 13);

/**
 * @generated from message memba.v1.Signature
 */
export type Signature = Message<"memba.v1.Signature"> & {
  /**
   * @generated from field: string value = 1;
   */
  value: string;

  /**
   * @generated from field: string user_address = 2;
   */
  userAddress: string;

  /**
   * @generated from field: bytes body_bytes = 3;
   */
  bodyBytes: Uint8Array;

  /**
   * @generated from field: string created_at = 4;
   */
  createdAt: string;

  /**
   * verified: the backend's server-side signature check (A3) passed for this
   * signature at submission time. Recorded in both log-only and enforce modes;
   * false = stored but not cryptographically verified — including all rows
   * submitted before this field existed.
   *
   * @generated from field: bool verified = 5;
   */
  verified: boolean;
};

/**
 * Describes the message memba.v1.Signature.
 * Use `create(SignatureSchema)` to create a new message.
 */
export const SignatureSchema: GenMessage<Signature> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 14);

/**
 * @generated from message memba.v1.Transaction
 */
export type Transaction = Message<"memba.v1.Transaction"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string created_at = 2;
   */
  createdAt: string;

  /**
   * @generated from field: string final_hash = 3;
   */
  finalHash: string;

  /**
   * @generated from field: string multisig_address = 4;
   */
  multisigAddress: string;

  /**
   * @generated from field: string chain_id = 5;
   */
  chainId: string;

  /**
   * @generated from field: string msgs_json = 6;
   */
  msgsJson: string;

  /**
   * @generated from field: string fee_json = 7;
   */
  feeJson: string;

  /**
   * @generated from field: uint32 account_number = 8;
   */
  accountNumber: number;

  /**
   * @generated from field: uint32 sequence = 9;
   */
  sequence: number;

  /**
   * @generated from field: string creator_address = 10;
   */
  creatorAddress: string;

  /**
   * @generated from field: uint32 threshold = 11;
   */
  threshold: number;

  /**
   * @generated from field: uint32 members_count = 12;
   */
  membersCount: number;

  /**
   * @generated from field: string memo = 13;
   */
  memo: string;

  /**
   * @generated from field: repeated memba.v1.Signature signatures = 14;
   */
  signatures: Signature[];

  /**
   * @generated from field: string multisig_pubkey_json = 15;
   */
  multisigPubkeyJson: string;

  /**
   * @generated from field: string type = 16;
   */
  type: string;

  /**
   * verified: the backend confirmed final_hash exists on-chain at completion
   * time (best-effort). false = client-claimed, unconfirmed (W2.3 / BE-3).
   *
   * @generated from field: bool verified = 17;
   */
  verified: boolean;
};

/**
 * Describes the message memba.v1.Transaction.
 * Use `create(TransactionSchema)` to create a new message.
 */
export const TransactionSchema: GenMessage<Transaction> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 15);

/**
 * @generated from message memba.v1.CreateTransactionRequest
 */
export type CreateTransactionRequest = Message<"memba.v1.CreateTransactionRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string multisig_address = 2;
   */
  multisigAddress: string;

  /**
   * @generated from field: uint32 account_number = 3;
   */
  accountNumber: number;

  /**
   * @generated from field: uint32 sequence = 4;
   */
  sequence: number;

  /**
   * @generated from field: string msgs_json = 5;
   */
  msgsJson: string;

  /**
   * @generated from field: string fee_json = 6;
   */
  feeJson: string;

  /**
   * @generated from field: string chain_id = 7;
   */
  chainId: string;

  /**
   * @generated from field: string memo = 8;
   */
  memo: string;

  /**
   * @generated from field: string type = 9;
   */
  type: string;
};

/**
 * Describes the message memba.v1.CreateTransactionRequest.
 * Use `create(CreateTransactionRequestSchema)` to create a new message.
 */
export const CreateTransactionRequestSchema: GenMessage<CreateTransactionRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 16);

/**
 * @generated from message memba.v1.CreateTransactionResponse
 */
export type CreateTransactionResponse = Message<"memba.v1.CreateTransactionResponse"> & {
  /**
   * @generated from field: uint32 transaction_id = 1;
   */
  transactionId: number;
};

/**
 * Describes the message memba.v1.CreateTransactionResponse.
 * Use `create(CreateTransactionResponseSchema)` to create a new message.
 */
export const CreateTransactionResponseSchema: GenMessage<CreateTransactionResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 17);

/**
 * @generated from message memba.v1.TransactionsRequest
 */
export type TransactionsRequest = Message<"memba.v1.TransactionsRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: uint32 limit = 2;
   */
  limit: number;

  /**
   * @generated from field: string start_after = 3;
   */
  startAfter: string;

  /**
   * @generated from field: string multisig_address = 4;
   */
  multisigAddress: string;

  /**
   * @generated from field: string chain_id = 5;
   */
  chainId: string;

  /**
   * @generated from field: memba.v1.ExecutionState execution_state = 6;
   */
  executionState: ExecutionState;
};

/**
 * Describes the message memba.v1.TransactionsRequest.
 * Use `create(TransactionsRequestSchema)` to create a new message.
 */
export const TransactionsRequestSchema: GenMessage<TransactionsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 18);

/**
 * @generated from message memba.v1.TransactionsResponse
 */
export type TransactionsResponse = Message<"memba.v1.TransactionsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.Transaction transactions = 1;
   */
  transactions: Transaction[];
};

/**
 * Describes the message memba.v1.TransactionsResponse.
 * Use `create(TransactionsResponseSchema)` to create a new message.
 */
export const TransactionsResponseSchema: GenMessage<TransactionsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 19);

/**
 * @generated from message memba.v1.GetTransactionRequest
 */
export type GetTransactionRequest = Message<"memba.v1.GetTransactionRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: uint32 transaction_id = 2;
   */
  transactionId: number;
};

/**
 * Describes the message memba.v1.GetTransactionRequest.
 * Use `create(GetTransactionRequestSchema)` to create a new message.
 */
export const GetTransactionRequestSchema: GenMessage<GetTransactionRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 20);

/**
 * @generated from message memba.v1.GetTransactionResponse
 */
export type GetTransactionResponse = Message<"memba.v1.GetTransactionResponse"> & {
  /**
   * @generated from field: memba.v1.Transaction transaction = 1;
   */
  transaction?: Transaction | undefined;

  /**
   * Native node-encoded artifact, available only after full aggregate verification.
   *
   * @generated from field: bytes native_tx_bytes = 2;
   */
  nativeTxBytes: Uint8Array;

  /**
   * @generated from field: string native_tx_json = 3;
   */
  nativeTxJson: string;

  /**
   * @generated from field: string native_export_error = 4;
   */
  nativeExportError: string;
};

/**
 * Describes the message memba.v1.GetTransactionResponse.
 * Use `create(GetTransactionResponseSchema)` to create a new message.
 */
export const GetTransactionResponseSchema: GenMessage<GetTransactionResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 21);

/**
 * @generated from message memba.v1.SignTransactionRequest
 */
export type SignTransactionRequest = Message<"memba.v1.SignTransactionRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string signature = 2;
   */
  signature: string;

  /**
   * @generated from field: uint32 transaction_id = 3;
   */
  transactionId: number;

  /**
   * @generated from field: bytes body_bytes = 4;
   */
  bodyBytes: Uint8Array;
};

/**
 * Describes the message memba.v1.SignTransactionRequest.
 * Use `create(SignTransactionRequestSchema)` to create a new message.
 */
export const SignTransactionRequestSchema: GenMessage<SignTransactionRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 22);

/**
 * @generated from message memba.v1.SignTransactionResponse
 */
export type SignTransactionResponse = Message<"memba.v1.SignTransactionResponse"> & {
};

/**
 * Describes the message memba.v1.SignTransactionResponse.
 * Use `create(SignTransactionResponseSchema)` to create a new message.
 */
export const SignTransactionResponseSchema: GenMessage<SignTransactionResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 23);

/**
 * @generated from message memba.v1.CompleteTransactionRequest
 */
export type CompleteTransactionRequest = Message<"memba.v1.CompleteTransactionRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: uint32 transaction_id = 2;
   */
  transactionId: number;

  /**
   * @generated from field: string final_hash = 3;
   */
  finalHash: string;
};

/**
 * Describes the message memba.v1.CompleteTransactionRequest.
 * Use `create(CompleteTransactionRequestSchema)` to create a new message.
 */
export const CompleteTransactionRequestSchema: GenMessage<CompleteTransactionRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 24);

/**
 * @generated from message memba.v1.CompleteTransactionResponse
 */
export type CompleteTransactionResponse = Message<"memba.v1.CompleteTransactionResponse"> & {
};

/**
 * Describes the message memba.v1.CompleteTransactionResponse.
 * Use `create(CompleteTransactionResponseSchema)` to create a new message.
 */
export const CompleteTransactionResponseSchema: GenMessage<CompleteTransactionResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 25);

/**
 * @generated from message memba.v1.Profile
 */
export type Profile = Message<"memba.v1.Profile"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: string bio = 2;
   */
  bio: string;

  /**
   * @generated from field: string company = 3;
   */
  company: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string avatar_url = 5;
   */
  avatarUrl: string;

  /**
   * @generated from field: string twitter = 6;
   */
  twitter: string;

  /**
   * @generated from field: string github = 7;
   */
  github: string;

  /**
   * @generated from field: string website = 8;
   */
  website: string;

  /**
   * @generated from field: string updated_at = 9;
   */
  updatedAt: string;
};

/**
 * Describes the message memba.v1.Profile.
 * Use `create(ProfileSchema)` to create a new message.
 */
export const ProfileSchema: GenMessage<Profile> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 26);

/**
 * @generated from message memba.v1.GetProfileRequest
 */
export type GetProfileRequest = Message<"memba.v1.GetProfileRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message memba.v1.GetProfileRequest.
 * Use `create(GetProfileRequestSchema)` to create a new message.
 */
export const GetProfileRequestSchema: GenMessage<GetProfileRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 27);

/**
 * @generated from message memba.v1.GetProfileResponse
 */
export type GetProfileResponse = Message<"memba.v1.GetProfileResponse"> & {
  /**
   * @generated from field: memba.v1.Profile profile = 1;
   */
  profile?: Profile | undefined;
};

/**
 * Describes the message memba.v1.GetProfileResponse.
 * Use `create(GetProfileResponseSchema)` to create a new message.
 */
export const GetProfileResponseSchema: GenMessage<GetProfileResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 28);

/**
 * @generated from message memba.v1.UpdateProfileRequest
 */
export type UpdateProfileRequest = Message<"memba.v1.UpdateProfileRequest"> & {
  /**
   * must match profile.address
   *
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: memba.v1.Profile profile = 2;
   */
  profile?: Profile | undefined;
};

/**
 * Describes the message memba.v1.UpdateProfileRequest.
 * Use `create(UpdateProfileRequestSchema)` to create a new message.
 */
export const UpdateProfileRequestSchema: GenMessage<UpdateProfileRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 29);

/**
 * @generated from message memba.v1.UpdateProfileResponse
 */
export type UpdateProfileResponse = Message<"memba.v1.UpdateProfileResponse"> & {
  /**
   * @generated from field: memba.v1.Profile profile = 1;
   */
  profile?: Profile | undefined;
};

/**
 * Describes the message memba.v1.UpdateProfileResponse.
 * Use `create(UpdateProfileResponseSchema)` to create a new message.
 */
export const UpdateProfileResponseSchema: GenMessage<UpdateProfileResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 30);

/**
 * @generated from message memba.v1.QuestCompletion
 */
export type QuestCompletion = Message<"memba.v1.QuestCompletion"> & {
  /**
   * @generated from field: string quest_id = 1;
   */
  questId: string;

  /**
   * RFC3339
   *
   * @generated from field: string completed_at = 2;
   */
  completedAt: string;
};

/**
 * Describes the message memba.v1.QuestCompletion.
 * Use `create(QuestCompletionSchema)` to create a new message.
 */
export const QuestCompletionSchema: GenMessage<QuestCompletion> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 31);

/**
 * @generated from message memba.v1.UserQuestState
 */
export type UserQuestState = Message<"memba.v1.UserQuestState"> & {
  /**
   * @generated from field: repeated memba.v1.QuestCompletion completed = 1;
   */
  completed: QuestCompletion[];

  /**
   * @generated from field: uint32 total_xp = 2;
   */
  totalXp: number;

  /**
   * verified_xp counts only proof-backed completions: on_chain quests
   * (server re-verified at grant time) and self_report quests with an
   * admin-approved claim. off_chain/social/legacy XP is excluded — the
   * candidature gate (350 XP) reads this, not total_xp (BE-4).
   *
   * @generated from field: uint32 verified_xp = 3;
   */
  verifiedXp: number;
};

/**
 * Describes the message memba.v1.UserQuestState.
 * Use `create(UserQuestStateSchema)` to create a new message.
 */
export const UserQuestStateSchema: GenMessage<UserQuestState> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 32);

/**
 * @generated from message memba.v1.CompleteQuestRequest
 */
export type CompleteQuestRequest = Message<"memba.v1.CompleteQuestRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string quest_id = 2;
   */
  questId: string;

  /**
   * proof is an optional realm/package path for deploy quests, verified
   * server-side against the user's registered @username namespace.
   *
   * @generated from field: string proof = 3;
   */
  proof: string;
};

/**
 * Describes the message memba.v1.CompleteQuestRequest.
 * Use `create(CompleteQuestRequestSchema)` to create a new message.
 */
export const CompleteQuestRequestSchema: GenMessage<CompleteQuestRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 33);

/**
 * @generated from message memba.v1.CompleteQuestResponse
 */
export type CompleteQuestResponse = Message<"memba.v1.CompleteQuestResponse"> & {
  /**
   * @generated from field: memba.v1.UserQuestState state = 1;
   */
  state?: UserQuestState | undefined;
};

/**
 * Describes the message memba.v1.CompleteQuestResponse.
 * Use `create(CompleteQuestResponseSchema)` to create a new message.
 */
export const CompleteQuestResponseSchema: GenMessage<CompleteQuestResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 34);

/**
 * @generated from message memba.v1.GetUserQuestsRequest
 */
export type GetUserQuestsRequest = Message<"memba.v1.GetUserQuestsRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message memba.v1.GetUserQuestsRequest.
 * Use `create(GetUserQuestsRequestSchema)` to create a new message.
 */
export const GetUserQuestsRequestSchema: GenMessage<GetUserQuestsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 35);

/**
 * @generated from message memba.v1.GetUserQuestsResponse
 */
export type GetUserQuestsResponse = Message<"memba.v1.GetUserQuestsResponse"> & {
  /**
   * @generated from field: memba.v1.UserQuestState state = 1;
   */
  state?: UserQuestState | undefined;

  /**
   * Self-report claim statuses for this address, so the user can see a
   * pending/rejected claim (and resubmit after rejection). Status only — proof
   * contents stay off this public, unauthenticated endpoint.
   *
   * @generated from field: repeated memba.v1.QuestClaimStatus claim_statuses = 2;
   */
  claimStatuses: QuestClaimStatus[];
};

/**
 * Describes the message memba.v1.GetUserQuestsResponse.
 * Use `create(GetUserQuestsResponseSchema)` to create a new message.
 */
export const GetUserQuestsResponseSchema: GenMessage<GetUserQuestsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 36);

/**
 * QuestClaimStatus is the public-safe view of a quest_claims row: the claim's
 * lifecycle state without the submitted proof.
 *
 * @generated from message memba.v1.QuestClaimStatus
 */
export type QuestClaimStatus = Message<"memba.v1.QuestClaimStatus"> & {
  /**
   * @generated from field: string quest_id = 1;
   */
  questId: string;

  /**
   * "pending", "approved", "rejected"
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * submission time (SQLite DATETIME string)
   *
   * @generated from field: string created_at = 3;
   */
  createdAt: string;

  /**
   * review time; empty while pending
   *
   * @generated from field: string reviewed_at = 4;
   */
  reviewedAt: string;
};

/**
 * Describes the message memba.v1.QuestClaimStatus.
 * Use `create(QuestClaimStatusSchema)` to create a new message.
 */
export const QuestClaimStatusSchema: GenMessage<QuestClaimStatus> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 37);

/**
 * AttestationVoucher is a backend-signed voucher the user broadcasts to the
 * memba_quest_attestation_v1 realm: RecordCompletion(address, quest_id, xp,
 * nonce, sig_hex). The signature is over canonical "address|quest_id|xp|nonce".
 *
 * @generated from message memba.v1.AttestationVoucher
 */
export type AttestationVoucher = Message<"memba.v1.AttestationVoucher"> & {
  /**
   * @generated from field: string quest_id = 1;
   */
  questId: string;

  /**
   * @generated from field: uint32 xp = 2;
   */
  xp: number;

  /**
   * @generated from field: string nonce = 3;
   */
  nonce: string;

  /**
   * hex ed25519 signature
   *
   * @generated from field: string sig_hex = 4;
   */
  sigHex: string;
};

/**
 * Describes the message memba.v1.AttestationVoucher.
 * Use `create(AttestationVoucherSchema)` to create a new message.
 */
export const AttestationVoucherSchema: GenMessage<AttestationVoucher> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 38);

/**
 * @generated from message memba.v1.GetAttestationVouchersRequest
 */
export type GetAttestationVouchersRequest = Message<"memba.v1.GetAttestationVouchersRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message memba.v1.GetAttestationVouchersRequest.
 * Use `create(GetAttestationVouchersRequestSchema)` to create a new message.
 */
export const GetAttestationVouchersRequestSchema: GenMessage<GetAttestationVouchersRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 39);

/**
 * @generated from message memba.v1.GetAttestationVouchersResponse
 */
export type GetAttestationVouchersResponse = Message<"memba.v1.GetAttestationVouchersResponse"> & {
  /**
   * @generated from field: repeated memba.v1.AttestationVoucher vouchers = 1;
   */
  vouchers: AttestationVoucher[];

  /**
   * realm_path + signer_pubkey_hex are echoed so the client can build/verify the
   * broadcast call without hardcoding them. Empty when attestation is disabled.
   *
   * @generated from field: string realm_path = 2;
   */
  realmPath: string;

  /**
   * @generated from field: string signer_pubkey_hex = 3;
   */
  signerPubkeyHex: string;
};

/**
 * Describes the message memba.v1.GetAttestationVouchersResponse.
 * Use `create(GetAttestationVouchersResponseSchema)` to create a new message.
 */
export const GetAttestationVouchersResponseSchema: GenMessage<GetAttestationVouchersResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 40);

/**
 * SyncQuests allows the frontend to upload localStorage quests on first backend connection.
 * The server validates each quest_id and ignores duplicates. completed_at is preserved from client.
 *
 * @generated from message memba.v1.SyncQuestsRequest
 */
export type SyncQuestsRequest = Message<"memba.v1.SyncQuestsRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: repeated memba.v1.QuestCompletion completions = 2;
   */
  completions: QuestCompletion[];
};

/**
 * Describes the message memba.v1.SyncQuestsRequest.
 * Use `create(SyncQuestsRequestSchema)` to create a new message.
 */
export const SyncQuestsRequestSchema: GenMessage<SyncQuestsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 41);

/**
 * @generated from message memba.v1.SyncQuestsResponse
 */
export type SyncQuestsResponse = Message<"memba.v1.SyncQuestsResponse"> & {
  /**
   * @generated from field: memba.v1.UserQuestState state = 1;
   */
  state?: UserQuestState | undefined;
};

/**
 * Describes the message memba.v1.SyncQuestsResponse.
 * Use `create(SyncQuestsResponseSchema)` to create a new message.
 */
export const SyncQuestsResponseSchema: GenMessage<SyncQuestsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 42);

/**
 * @generated from message memba.v1.RankInfo
 */
export type RankInfo = Message<"memba.v1.RankInfo"> & {
  /**
   * @generated from field: uint32 tier = 1;
   */
  tier: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 total_xp = 3;
   */
  totalXp: number;

  /**
   * @generated from field: uint32 quests_completed = 4;
   */
  questsCompleted: number;

  /**
   * @generated from field: uint32 next_rank_xp = 5;
   */
  nextRankXp: number;
};

/**
 * Describes the message memba.v1.RankInfo.
 * Use `create(RankInfoSchema)` to create a new message.
 */
export const RankInfoSchema: GenMessage<RankInfo> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 43);

/**
 * @generated from message memba.v1.GetUserRankRequest
 */
export type GetUserRankRequest = Message<"memba.v1.GetUserRankRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message memba.v1.GetUserRankRequest.
 * Use `create(GetUserRankRequestSchema)` to create a new message.
 */
export const GetUserRankRequestSchema: GenMessage<GetUserRankRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 44);

/**
 * @generated from message memba.v1.GetUserRankResponse
 */
export type GetUserRankResponse = Message<"memba.v1.GetUserRankResponse"> & {
  /**
   * @generated from field: memba.v1.RankInfo rank = 1;
   */
  rank?: RankInfo | undefined;
};

/**
 * Describes the message memba.v1.GetUserRankResponse.
 * Use `create(GetUserRankResponseSchema)` to create a new message.
 */
export const GetUserRankResponseSchema: GenMessage<GetUserRankResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 45);

/**
 * @generated from message memba.v1.LeaderboardEntry
 */
export type LeaderboardEntry = Message<"memba.v1.LeaderboardEntry"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: uint32 rank_tier = 3;
   */
  rankTier: number;

  /**
   * @generated from field: string rank_name = 4;
   */
  rankName: string;

  /**
   * @generated from field: uint32 total_xp = 5;
   */
  totalXp: number;

  /**
   * @generated from field: uint32 quests_completed = 6;
   */
  questsCompleted: number;

  /**
   * @generated from field: string avatar_url = 7;
   */
  avatarUrl: string;
};

/**
 * Describes the message memba.v1.LeaderboardEntry.
 * Use `create(LeaderboardEntrySchema)` to create a new message.
 */
export const LeaderboardEntrySchema: GenMessage<LeaderboardEntry> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 46);

/**
 * @generated from message memba.v1.GetLeaderboardRequest
 */
export type GetLeaderboardRequest = Message<"memba.v1.GetLeaderboardRequest"> & {
  /**
   * max entries to return (default 50, max 100)
   *
   * @generated from field: uint32 limit = 1;
   */
  limit: number;

  /**
   * pagination offset
   *
   * @generated from field: uint32 offset = 2;
   */
  offset: number;
};

/**
 * Describes the message memba.v1.GetLeaderboardRequest.
 * Use `create(GetLeaderboardRequestSchema)` to create a new message.
 */
export const GetLeaderboardRequestSchema: GenMessage<GetLeaderboardRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 47);

/**
 * @generated from message memba.v1.GetLeaderboardResponse
 */
export type GetLeaderboardResponse = Message<"memba.v1.GetLeaderboardResponse"> & {
  /**
   * @generated from field: repeated memba.v1.LeaderboardEntry entries = 1;
   */
  entries: LeaderboardEntry[];

  /**
   * @generated from field: uint32 total_count = 2;
   */
  totalCount: number;
};

/**
 * Describes the message memba.v1.GetLeaderboardResponse.
 * Use `create(GetLeaderboardResponseSchema)` to create a new message.
 */
export const GetLeaderboardResponseSchema: GenMessage<GetLeaderboardResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 48);

/**
 * @generated from message memba.v1.SubmitQuestClaimRequest
 */
export type SubmitQuestClaimRequest = Message<"memba.v1.SubmitQuestClaimRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string quest_id = 2;
   */
  questId: string;

  /**
   * screenshot, link, or repo URL
   *
   * @generated from field: string proof_url = 3;
   */
  proofUrl: string;

  /**
   * description of what was done
   *
   * @generated from field: string proof_text = 4;
   */
  proofText: string;
};

/**
 * Describes the message memba.v1.SubmitQuestClaimRequest.
 * Use `create(SubmitQuestClaimRequestSchema)` to create a new message.
 */
export const SubmitQuestClaimRequestSchema: GenMessage<SubmitQuestClaimRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 49);

/**
 * @generated from message memba.v1.SubmitQuestClaimResponse
 */
export type SubmitQuestClaimResponse = Message<"memba.v1.SubmitQuestClaimResponse"> & {
  /**
   * "pending"
   *
   * @generated from field: string status = 1;
   */
  status: string;
};

/**
 * Describes the message memba.v1.SubmitQuestClaimResponse.
 * Use `create(SubmitQuestClaimResponseSchema)` to create a new message.
 */
export const SubmitQuestClaimResponseSchema: GenMessage<SubmitQuestClaimResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 50);

/**
 * @generated from message memba.v1.ReviewQuestClaimRequest
 */
export type ReviewQuestClaimRequest = Message<"memba.v1.ReviewQuestClaimRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: int64 claim_id = 2;
   */
  claimId: bigint;

  /**
   * @generated from field: bool approved = 3;
   */
  approved: boolean;
};

/**
 * Describes the message memba.v1.ReviewQuestClaimRequest.
 * Use `create(ReviewQuestClaimRequestSchema)` to create a new message.
 */
export const ReviewQuestClaimRequestSchema: GenMessage<ReviewQuestClaimRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 51);

/**
 * @generated from message memba.v1.ReviewQuestClaimResponse
 */
export type ReviewQuestClaimResponse = Message<"memba.v1.ReviewQuestClaimResponse"> & {
  /**
   * "approved" or "rejected"
   *
   * @generated from field: string status = 1;
   */
  status: string;
};

/**
 * Describes the message memba.v1.ReviewQuestClaimResponse.
 * Use `create(ReviewQuestClaimResponseSchema)` to create a new message.
 */
export const ReviewQuestClaimResponseSchema: GenMessage<ReviewQuestClaimResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 52);

/**
 * @generated from message memba.v1.QuestClaim
 */
export type QuestClaim = Message<"memba.v1.QuestClaim"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * @generated from field: string quest_id = 3;
   */
  questId: string;

  /**
   * @generated from field: string proof_url = 4;
   */
  proofUrl: string;

  /**
   * @generated from field: string proof_text = 5;
   */
  proofText: string;

  /**
   * "pending", "approved", "rejected"
   *
   * @generated from field: string status = 6;
   */
  status: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message memba.v1.QuestClaim.
 * Use `create(QuestClaimSchema)` to create a new message.
 */
export const QuestClaimSchema: GenMessage<QuestClaim> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 53);

/**
 * @generated from message memba.v1.ListPendingClaimsRequest
 */
export type ListPendingClaimsRequest = Message<"memba.v1.ListPendingClaimsRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;
};

/**
 * Describes the message memba.v1.ListPendingClaimsRequest.
 * Use `create(ListPendingClaimsRequestSchema)` to create a new message.
 */
export const ListPendingClaimsRequestSchema: GenMessage<ListPendingClaimsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 54);

/**
 * @generated from message memba.v1.ListPendingClaimsResponse
 */
export type ListPendingClaimsResponse = Message<"memba.v1.ListPendingClaimsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.QuestClaim claims = 1;
   */
  claims: QuestClaim[];
};

/**
 * Describes the message memba.v1.ListPendingClaimsResponse.
 * Use `create(ListPendingClaimsResponseSchema)` to create a new message.
 */
export const ListPendingClaimsResponseSchema: GenMessage<ListPendingClaimsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 55);

/**
 * @generated from message memba.v1.Team
 */
export type Team = Message<"memba.v1.Team"> & {
  /**
   * UUID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * 8-char alphanumeric, unique
   *
   * @generated from field: string invite_code = 3;
   */
  inviteCode: string;

  /**
   * creator address
   *
   * @generated from field: string created_by = 4;
   */
  createdBy: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 5;
   */
  createdAt: string;

  /**
   * @generated from field: repeated memba.v1.TeamMember members = 6;
   */
  members: TeamMember[];

  /**
   * optional, max 500 chars
   *
   * @generated from field: string description = 7;
   */
  description: string;
};

/**
 * Describes the message memba.v1.Team.
 * Use `create(TeamSchema)` to create a new message.
 */
export const TeamSchema: GenMessage<Team> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 56);

/**
 * @generated from message memba.v1.TeamMember
 */
export type TeamMember = Message<"memba.v1.TeamMember"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: memba.v1.TeamRole role = 2;
   */
  role: TeamRole;

  /**
   * RFC3339
   *
   * @generated from field: string joined_at = 3;
   */
  joinedAt: string;
};

/**
 * Describes the message memba.v1.TeamMember.
 * Use `create(TeamMemberSchema)` to create a new message.
 */
export const TeamMemberSchema: GenMessage<TeamMember> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 57);

/**
 * @generated from message memba.v1.CreateTeamRequest
 */
export type CreateTeamRequest = Message<"memba.v1.CreateTeamRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * 1-64 chars
   *
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * optional, max 500 chars
   *
   * @generated from field: string description = 3;
   */
  description: string;
};

/**
 * Describes the message memba.v1.CreateTeamRequest.
 * Use `create(CreateTeamRequestSchema)` to create a new message.
 */
export const CreateTeamRequestSchema: GenMessage<CreateTeamRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 58);

/**
 * @generated from message memba.v1.CreateTeamResponse
 */
export type CreateTeamResponse = Message<"memba.v1.CreateTeamResponse"> & {
  /**
   * @generated from field: memba.v1.Team team = 1;
   */
  team?: Team | undefined;
};

/**
 * Describes the message memba.v1.CreateTeamResponse.
 * Use `create(CreateTeamResponseSchema)` to create a new message.
 */
export const CreateTeamResponseSchema: GenMessage<CreateTeamResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 59);

/**
 * @generated from message memba.v1.GetTeamRequest
 */
export type GetTeamRequest = Message<"memba.v1.GetTeamRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * Describes the message memba.v1.GetTeamRequest.
 * Use `create(GetTeamRequestSchema)` to create a new message.
 */
export const GetTeamRequestSchema: GenMessage<GetTeamRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 60);

/**
 * @generated from message memba.v1.GetTeamResponse
 */
export type GetTeamResponse = Message<"memba.v1.GetTeamResponse"> & {
  /**
   * @generated from field: memba.v1.Team team = 1;
   */
  team?: Team | undefined;
};

/**
 * Describes the message memba.v1.GetTeamResponse.
 * Use `create(GetTeamResponseSchema)` to create a new message.
 */
export const GetTeamResponseSchema: GenMessage<GetTeamResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 61);

/**
 * @generated from message memba.v1.GetMyTeamsRequest
 */
export type GetMyTeamsRequest = Message<"memba.v1.GetMyTeamsRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;
};

/**
 * Describes the message memba.v1.GetMyTeamsRequest.
 * Use `create(GetMyTeamsRequestSchema)` to create a new message.
 */
export const GetMyTeamsRequestSchema: GenMessage<GetMyTeamsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 62);

/**
 * @generated from message memba.v1.GetMyTeamsResponse
 */
export type GetMyTeamsResponse = Message<"memba.v1.GetMyTeamsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.Team teams = 1;
   */
  teams: Team[];
};

/**
 * Describes the message memba.v1.GetMyTeamsResponse.
 * Use `create(GetMyTeamsResponseSchema)` to create a new message.
 */
export const GetMyTeamsResponseSchema: GenMessage<GetMyTeamsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 63);

/**
 * @generated from message memba.v1.JoinTeamRequest
 */
export type JoinTeamRequest = Message<"memba.v1.JoinTeamRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string invite_code = 2;
   */
  inviteCode: string;
};

/**
 * Describes the message memba.v1.JoinTeamRequest.
 * Use `create(JoinTeamRequestSchema)` to create a new message.
 */
export const JoinTeamRequestSchema: GenMessage<JoinTeamRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 64);

/**
 * @generated from message memba.v1.JoinTeamResponse
 */
export type JoinTeamResponse = Message<"memba.v1.JoinTeamResponse"> & {
  /**
   * @generated from field: memba.v1.Team team = 1;
   */
  team?: Team | undefined;
};

/**
 * Describes the message memba.v1.JoinTeamResponse.
 * Use `create(JoinTeamResponseSchema)` to create a new message.
 */
export const JoinTeamResponseSchema: GenMessage<JoinTeamResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 65);

/**
 * @generated from message memba.v1.LeaveTeamRequest
 */
export type LeaveTeamRequest = Message<"memba.v1.LeaveTeamRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;
};

/**
 * Describes the message memba.v1.LeaveTeamRequest.
 * Use `create(LeaveTeamRequestSchema)` to create a new message.
 */
export const LeaveTeamRequestSchema: GenMessage<LeaveTeamRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 66);

/**
 * @generated from message memba.v1.LeaveTeamResponse
 */
export type LeaveTeamResponse = Message<"memba.v1.LeaveTeamResponse"> & {
};

/**
 * Describes the message memba.v1.LeaveTeamResponse.
 * Use `create(LeaveTeamResponseSchema)` to create a new message.
 */
export const LeaveTeamResponseSchema: GenMessage<LeaveTeamResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 67);

/**
 * @generated from message memba.v1.UpdateTeamMemberRoleRequest
 */
export type UpdateTeamMemberRoleRequest = Message<"memba.v1.UpdateTeamMemberRoleRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string member_address = 3;
   */
  memberAddress: string;

  /**
   * @generated from field: memba.v1.TeamRole role = 4;
   */
  role: TeamRole;
};

/**
 * Describes the message memba.v1.UpdateTeamMemberRoleRequest.
 * Use `create(UpdateTeamMemberRoleRequestSchema)` to create a new message.
 */
export const UpdateTeamMemberRoleRequestSchema: GenMessage<UpdateTeamMemberRoleRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 68);

/**
 * @generated from message memba.v1.UpdateTeamMemberRoleResponse
 */
export type UpdateTeamMemberRoleResponse = Message<"memba.v1.UpdateTeamMemberRoleResponse"> & {
  /**
   * @generated from field: memba.v1.Team team = 1;
   */
  team?: Team | undefined;
};

/**
 * Describes the message memba.v1.UpdateTeamMemberRoleResponse.
 * Use `create(UpdateTeamMemberRoleResponseSchema)` to create a new message.
 */
export const UpdateTeamMemberRoleResponseSchema: GenMessage<UpdateTeamMemberRoleResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 69);

/**
 * @generated from message memba.v1.FavoriteAgentRequest
 */
export type FavoriteAgentRequest = Message<"memba.v1.FavoriteAgentRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * on-chain agent ID
   *
   * @generated from field: string agent_id = 2;
   */
  agentId: string;
};

/**
 * Describes the message memba.v1.FavoriteAgentRequest.
 * Use `create(FavoriteAgentRequestSchema)` to create a new message.
 */
export const FavoriteAgentRequestSchema: GenMessage<FavoriteAgentRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 70);

/**
 * @generated from message memba.v1.FavoriteAgentResponse
 */
export type FavoriteAgentResponse = Message<"memba.v1.FavoriteAgentResponse"> & {
  /**
   * true = added, false = removed (toggle)
   *
   * @generated from field: bool favorited = 1;
   */
  favorited: boolean;
};

/**
 * Describes the message memba.v1.FavoriteAgentResponse.
 * Use `create(FavoriteAgentResponseSchema)` to create a new message.
 */
export const FavoriteAgentResponseSchema: GenMessage<FavoriteAgentResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 71);

/**
 * @generated from message memba.v1.GetFavoritesRequest
 */
export type GetFavoritesRequest = Message<"memba.v1.GetFavoritesRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;
};

/**
 * Describes the message memba.v1.GetFavoritesRequest.
 * Use `create(GetFavoritesRequestSchema)` to create a new message.
 */
export const GetFavoritesRequestSchema: GenMessage<GetFavoritesRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 72);

/**
 * @generated from message memba.v1.GetFavoritesResponse
 */
export type GetFavoritesResponse = Message<"memba.v1.GetFavoritesResponse"> & {
  /**
   * @generated from field: repeated string agent_ids = 1;
   */
  agentIds: string[];
};

/**
 * Describes the message memba.v1.GetFavoritesResponse.
 * Use `create(GetFavoritesResponseSchema)` to create a new message.
 */
export const GetFavoritesResponseSchema: GenMessage<GetFavoritesResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 73);

/**
 * @generated from message memba.v1.AgentStats
 */
export type AgentStats = Message<"memba.v1.AgentStats"> & {
  /**
   * @generated from field: string agent_id = 1;
   */
  agentId: string;

  /**
   * @generated from field: uint32 view_count = 2;
   */
  viewCount: number;

  /**
   * @generated from field: uint32 favorite_count = 3;
   */
  favoriteCount: number;
};

/**
 * Describes the message memba.v1.AgentStats.
 * Use `create(AgentStatsSchema)` to create a new message.
 */
export const AgentStatsSchema: GenMessage<AgentStats> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 74);

/**
 * @generated from message memba.v1.GetAgentStatsRequest
 */
export type GetAgentStatsRequest = Message<"memba.v1.GetAgentStatsRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string agent_id = 1;
   */
  agentId: string;
};

/**
 * Describes the message memba.v1.GetAgentStatsRequest.
 * Use `create(GetAgentStatsRequestSchema)` to create a new message.
 */
export const GetAgentStatsRequestSchema: GenMessage<GetAgentStatsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 75);

/**
 * @generated from message memba.v1.GetAgentStatsResponse
 */
export type GetAgentStatsResponse = Message<"memba.v1.GetAgentStatsResponse"> & {
  /**
   * @generated from field: memba.v1.AgentStats stats = 1;
   */
  stats?: AgentStats | undefined;
};

/**
 * Describes the message memba.v1.GetAgentStatsResponse.
 * Use `create(GetAgentStatsResponseSchema)` to create a new message.
 */
export const GetAgentStatsResponseSchema: GenMessage<GetAgentStatsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 76);

/**
 * @generated from message memba.v1.ServiceListing
 */
export type ServiceListing = Message<"memba.v1.ServiceListing"> & {
  /**
   * UUID
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * freelancer g1... address
   *
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * 1-200 chars
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * up to 2000 chars
   *
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * development, design, writing, consulting, marketing, other
   *
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * suggested price in ugnot
   *
   * @generated from field: uint64 price = 6;
   */
  price: bigint;

  /**
   * @generated from field: uint32 delivery_days = 7;
   */
  deliveryDays: number;

  /**
   * comma-separated
   *
   * @generated from field: string tags = 8;
   */
  tags: string;

  /**
   * @generated from field: bool active = 9;
   */
  active: boolean;

  /**
   * @generated from field: string created_at = 10;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 11;
   */
  updatedAt: string;
};

/**
 * Describes the message memba.v1.ServiceListing.
 * Use `create(ServiceListingSchema)` to create a new message.
 */
export const ServiceListingSchema: GenMessage<ServiceListing> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 77);

/**
 * @generated from message memba.v1.CreateServiceListingRequest
 */
export type CreateServiceListingRequest = Message<"memba.v1.CreateServiceListingRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string category = 4;
   */
  category: string;

  /**
   * ugnot
   *
   * @generated from field: uint64 price = 5;
   */
  price: bigint;

  /**
   * @generated from field: uint32 delivery_days = 6;
   */
  deliveryDays: number;

  /**
   * comma-separated
   *
   * @generated from field: string tags = 7;
   */
  tags: string;
};

/**
 * Describes the message memba.v1.CreateServiceListingRequest.
 * Use `create(CreateServiceListingRequestSchema)` to create a new message.
 */
export const CreateServiceListingRequestSchema: GenMessage<CreateServiceListingRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 78);

/**
 * @generated from message memba.v1.CreateServiceListingResponse
 */
export type CreateServiceListingResponse = Message<"memba.v1.CreateServiceListingResponse"> & {
  /**
   * @generated from field: memba.v1.ServiceListing listing = 1;
   */
  listing?: ServiceListing | undefined;
};

/**
 * Describes the message memba.v1.CreateServiceListingResponse.
 * Use `create(CreateServiceListingResponseSchema)` to create a new message.
 */
export const CreateServiceListingResponseSchema: GenMessage<CreateServiceListingResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 79);

/**
 * @generated from message memba.v1.GetServiceListingsRequest
 */
export type GetServiceListingsRequest = Message<"memba.v1.GetServiceListingsRequest"> & {
  /**
   * optional filter, empty = all
   *
   * @generated from field: string category = 1;
   */
  category: string;

  /**
   * default 50
   *
   * @generated from field: uint32 limit = 2;
   */
  limit: number;

  /**
   * cursor-based pagination
   *
   * @generated from field: string start_after = 3;
   */
  startAfter: string;
};

/**
 * Describes the message memba.v1.GetServiceListingsRequest.
 * Use `create(GetServiceListingsRequestSchema)` to create a new message.
 */
export const GetServiceListingsRequestSchema: GenMessage<GetServiceListingsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 80);

/**
 * @generated from message memba.v1.GetServiceListingsResponse
 */
export type GetServiceListingsResponse = Message<"memba.v1.GetServiceListingsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.ServiceListing listings = 1;
   */
  listings: ServiceListing[];
};

/**
 * Describes the message memba.v1.GetServiceListingsResponse.
 * Use `create(GetServiceListingsResponseSchema)` to create a new message.
 */
export const GetServiceListingsResponseSchema: GenMessage<GetServiceListingsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 81);

/**
 * @generated from message memba.v1.UpdateServiceListingRequest
 */
export type UpdateServiceListingRequest = Message<"memba.v1.UpdateServiceListingRequest"> & {
  /**
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string listing_id = 2;
   */
  listingId: string;

  /**
   * empty = no change
   *
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string description = 4;
   */
  description: string;

  /**
   * @generated from field: string category = 5;
   */
  category: string;

  /**
   * 0 = no change
   *
   * @generated from field: uint64 price = 6;
   */
  price: bigint;

  /**
   * 0 = no change
   *
   * @generated from field: uint32 delivery_days = 7;
   */
  deliveryDays: number;

  /**
   * @generated from field: string tags = 8;
   */
  tags: string;

  /**
   * toggle active/paused
   *
   * @generated from field: bool active = 9;
   */
  active: boolean;
};

/**
 * Describes the message memba.v1.UpdateServiceListingRequest.
 * Use `create(UpdateServiceListingRequestSchema)` to create a new message.
 */
export const UpdateServiceListingRequestSchema: GenMessage<UpdateServiceListingRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 82);

/**
 * @generated from message memba.v1.UpdateServiceListingResponse
 */
export type UpdateServiceListingResponse = Message<"memba.v1.UpdateServiceListingResponse"> & {
  /**
   * @generated from field: memba.v1.ServiceListing listing = 1;
   */
  listing?: ServiceListing | undefined;
};

/**
 * Describes the message memba.v1.UpdateServiceListingResponse.
 * Use `create(UpdateServiceListingResponseSchema)` to create a new message.
 */
export const UpdateServiceListingResponseSchema: GenMessage<UpdateServiceListingResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 83);

/**
 * NFTToken is a single token's cached state.
 *
 * @generated from message memba.v1.NFTToken
 */
export type NFTToken = Message<"memba.v1.NFTToken"> & {
  /**
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * @generated from field: string token_id = 2;
   */
  tokenId: string;

  /**
   * @generated from field: string owner = 3;
   */
  owner: string;

  /**
   * @generated from field: string uri = 4;
   */
  uri: string;

  /**
   * @generated from field: bool listed = 5;
   */
  listed: boolean;

  /**
   * 0 when not listed / unknown
   *
   * @generated from field: uint64 price_ugnot = 6;
   */
  priceUgnot: bigint;
};

/**
 * Describes the message memba.v1.NFTToken.
 * Use `create(NFTTokenSchema)` to create a new message.
 */
export const NFTTokenSchema: GenMessage<NFTToken> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 84);

/**
 * NFTActivity is a single cached marketplace event (currently sales).
 *
 * @generated from message memba.v1.NFTActivity
 */
export type NFTActivity = Message<"memba.v1.NFTActivity"> & {
  /**
   * @generated from field: uint64 sale_no = 1;
   */
  saleNo: bigint;

  /**
   * @generated from field: string token_id = 2;
   */
  tokenId: string;

  /**
   * e.g. "sale"
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: uint64 price_ugnot = 4;
   */
  priceUgnot: bigint;

  /**
   * may be empty/truncated (Render limitation)
   *
   * @generated from field: string seller = 5;
   */
  seller: string;

  /**
   * may be empty/truncated (Render limitation)
   *
   * @generated from field: string buyer = 6;
   */
  buyer: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 7;
   */
  createdAt: string;
};

/**
 * Describes the message memba.v1.NFTActivity.
 * Use `create(NFTActivitySchema)` to create a new message.
 */
export const NFTActivitySchema: GenMessage<NFTActivity> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 85);

/**
 * @generated from message memba.v1.GetNFTCollectionRequest
 */
export type GetNFTCollectionRequest = Message<"memba.v1.GetNFTCollectionRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;
};

/**
 * Describes the message memba.v1.GetNFTCollectionRequest.
 * Use `create(GetNFTCollectionRequestSchema)` to create a new message.
 */
export const GetNFTCollectionRequestSchema: GenMessage<GetNFTCollectionRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 86);

/**
 * @generated from message memba.v1.GetNFTCollectionResponse
 */
export type GetNFTCollectionResponse = Message<"memba.v1.GetNFTCollectionResponse"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string symbol = 2;
   */
  symbol: string;

  /**
   * @generated from field: uint64 supply = 3;
   */
  supply: bigint;

  /**
   * 0 = unknown (e.g. market home route unreachable)
   *
   * @generated from field: uint64 floor_price_ugnot = 4;
   */
  floorPriceUgnot: bigint;

  /**
   * @generated from field: uint64 total_volume_ugnot = 5;
   */
  totalVolumeUgnot: bigint;

  /**
   * @generated from field: uint64 total_sales = 6;
   */
  totalSales: bigint;

  /**
   * @generated from field: uint64 active_listings = 7;
   */
  activeListings: bigint;

  /**
   * @generated from field: uint64 royalty_bps = 8;
   */
  royaltyBps: bigint;
};

/**
 * Describes the message memba.v1.GetNFTCollectionResponse.
 * Use `create(GetNFTCollectionResponseSchema)` to create a new message.
 */
export const GetNFTCollectionResponseSchema: GenMessage<GetNFTCollectionResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 87);

/**
 * @generated from message memba.v1.GetNFTActivityRequest
 */
export type GetNFTActivityRequest = Message<"memba.v1.GetNFTActivityRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * default 50, max 500 — event tables hold full history
   *
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetNFTActivityRequest.
 * Use `create(GetNFTActivityRequestSchema)` to create a new message.
 */
export const GetNFTActivityRequestSchema: GenMessage<GetNFTActivityRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 88);

/**
 * @generated from message memba.v1.GetNFTActivityResponse
 */
export type GetNFTActivityResponse = Message<"memba.v1.GetNFTActivityResponse"> & {
  /**
   * @generated from field: repeated memba.v1.NFTActivity items = 1;
   */
  items: NFTActivity[];
};

/**
 * Describes the message memba.v1.GetNFTActivityResponse.
 * Use `create(GetNFTActivityResponseSchema)` to create a new message.
 */
export const GetNFTActivityResponseSchema: GenMessage<GetNFTActivityResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 89);

/**
 * @generated from message memba.v1.GetNFTPortfolioRequest
 */
export type GetNFTPortfolioRequest = Message<"memba.v1.GetNFTPortfolioRequest"> & {
  /**
   * g1... address; no auth required — public read
   *
   * @generated from field: string owner = 1;
   */
  owner: string;
};

/**
 * Describes the message memba.v1.GetNFTPortfolioRequest.
 * Use `create(GetNFTPortfolioRequestSchema)` to create a new message.
 */
export const GetNFTPortfolioRequestSchema: GenMessage<GetNFTPortfolioRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 90);

/**
 * @generated from message memba.v1.GetNFTPortfolioResponse
 */
export type GetNFTPortfolioResponse = Message<"memba.v1.GetNFTPortfolioResponse"> & {
  /**
   * @generated from field: repeated memba.v1.NFTToken tokens = 1;
   */
  tokens: NFTToken[];
};

/**
 * Describes the message memba.v1.GetNFTPortfolioResponse.
 * Use `create(GetNFTPortfolioResponseSchema)` to create a new message.
 */
export const GetNFTPortfolioResponseSchema: GenMessage<GetNFTPortfolioResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 91);

/**
 * @generated from message memba.v1.ListNFTTokensRequest
 */
export type ListNFTTokensRequest = Message<"memba.v1.ListNFTTokensRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string collection_id = 1;
   */
  collectionId: string;

  /**
   * when true, only return listed tokens
   *
   * @generated from field: bool listed_only = 2;
   */
  listedOnly: boolean;
};

/**
 * Describes the message memba.v1.ListNFTTokensRequest.
 * Use `create(ListNFTTokensRequestSchema)` to create a new message.
 */
export const ListNFTTokensRequestSchema: GenMessage<ListNFTTokensRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 92);

/**
 * @generated from message memba.v1.ListNFTTokensResponse
 */
export type ListNFTTokensResponse = Message<"memba.v1.ListNFTTokensResponse"> & {
  /**
   * @generated from field: repeated memba.v1.NFTToken tokens = 1;
   */
  tokens: NFTToken[];
};

/**
 * Describes the message memba.v1.ListNFTTokensResponse.
 * Use `create(ListNFTTokensResponseSchema)` to create a new message.
 */
export const ListNFTTokensResponseSchema: GenMessage<ListNFTTokensResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 93);

/**
 * NetworkPulse is the chain liveness summary.
 *
 * @generated from message memba.v1.NetworkPulse
 */
export type NetworkPulse = Message<"memba.v1.NetworkPulse"> & {
  /**
   * 0 = unknown
   *
   * @generated from field: int64 block_height = 1;
   */
  blockHeight: bigint;

  /**
   * 0 = unknown / not computed in v1
   *
   * @generated from field: int64 avg_block_time_ms = 2;
   */
  avgBlockTimeMs: bigint;

  /**
   * @generated from field: uint32 validators_total = 3;
   */
  validatorsTotal: number;
};

/**
 * Describes the message memba.v1.NetworkPulse.
 * Use `create(NetworkPulseSchema)` to create a new message.
 */
export const NetworkPulseSchema: GenMessage<NetworkPulse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 94);

/**
 * EcosystemCounts are the per-feature live counts that feed the Ecosystem tiles.
 * NOTE: `daos` is intentionally absent — it is sourced client-side from the
 * gnoweb namespace (same class as gnolove), not from the on-chain stampede.
 *
 * @generated from message memba.v1.EcosystemCounts
 */
export type EcosystemCounts = Message<"memba.v1.EcosystemCounts"> & {
  /**
   * 0 = unknown / source failed
   *
   * @generated from field: uint32 tokens = 1;
   */
  tokens: number;

  /**
   * @generated from field: uint32 collections = 2;
   */
  collections: number;

  /**
   * @generated from field: uint32 agents = 3;
   */
  agents: number;

  /**
   * @generated from field: uint32 validators = 4;
   */
  validators: number;
};

/**
 * Describes the message memba.v1.EcosystemCounts.
 * Use `create(EcosystemCountsSchema)` to create a new message.
 */
export const EcosystemCountsSchema: GenMessage<EcosystemCounts> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 95);

/**
 * FeaturedDao is the configured headline DAO's summary state.
 *
 * @generated from message memba.v1.FeaturedDao
 */
export type FeaturedDao = Message<"memba.v1.FeaturedDao"> & {
  /**
   * @generated from field: string realm_path = 1;
   */
  realmPath: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: uint32 members = 3;
   */
  members: number;

  /**
   * 0 = unknown (best-effort bank query)
   *
   * @generated from field: uint64 treasury_ugnot = 4;
   */
  treasuryUgnot: bigint;

  /**
   * @generated from field: uint32 open_proposals = 5;
   */
  openProposals: number;

  /**
   * @generated from field: string latest_proposal_title = 6;
   */
  latestProposalTitle: string;
};

/**
 * Describes the message memba.v1.FeaturedDao.
 * Use `create(FeaturedDaoSchema)` to create a new message.
 */
export const FeaturedDaoSchema: GenMessage<FeaturedDao> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 96);

/**
 * ValidatorsHealth is the cheap network-health subset (no per-validator signatures).
 *
 * @generated from message memba.v1.ValidatorsHealth
 */
export type ValidatorsHealth = Message<"memba.v1.ValidatorsHealth"> & {
  /**
   * "healthy" | "degraded" | "down"
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * @generated from field: uint32 active = 2;
   */
  active: number;

  /**
   * @generated from field: uint32 total = 3;
   */
  total: number;
};

/**
 * Describes the message memba.v1.ValidatorsHealth.
 * Use `create(ValidatorsHealthSchema)` to create a new message.
 */
export const ValidatorsHealthSchema: GenMessage<ValidatorsHealth> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 97);

/**
 * DirectoryMember is one on-chain users-registry entry (preview).
 *
 * @generated from message memba.v1.DirectoryMember
 */
export type DirectoryMember = Message<"memba.v1.DirectoryMember"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string address = 2;
   */
  address: string;

  /**
   * @generated from field: string avatar_url = 3;
   */
  avatarUrl: string;
};

/**
 * Describes the message memba.v1.DirectoryMember.
 * Use `create(DirectoryMemberSchema)` to create a new message.
 */
export const DirectoryMemberSchema: GenMessage<DirectoryMember> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 98);

/**
 * HomeSnapshot is the assembled global home payload. Every field tolerates its
 * source failing (zero/empty + listed in stale_sources); the call never fails wholesale.
 *
 * @generated from message memba.v1.HomeSnapshot
 */
export type HomeSnapshot = Message<"memba.v1.HomeSnapshot"> & {
  /**
   * @generated from field: memba.v1.NetworkPulse network = 1;
   */
  network?: NetworkPulse | undefined;

  /**
   * @generated from field: memba.v1.EcosystemCounts counts = 2;
   */
  counts?: EcosystemCounts | undefined;

  /**
   * @generated from field: memba.v1.FeaturedDao featured_dao = 3;
   */
  featuredDao?: FeaturedDao | undefined;

  /**
   * @generated from field: memba.v1.ValidatorsHealth validators_health = 4;
   */
  validatorsHealth?: ValidatorsHealth | undefined;

  /**
   * @generated from field: repeated memba.v1.DirectoryMember directory_members = 5;
   */
  directoryMembers: DirectoryMember[];

  /**
   * @generated from field: int64 as_of_block = 6;
   */
  asOfBlock: bigint;

  /**
   * max(last_processed_block) across indexed realms
   *
   * @generated from field: int64 indexer_last_block = 7;
   */
  indexerLastBlock: bigint;

  /**
   * RFC3339
   *
   * @generated from field: string generated_at = 8;
   */
  generatedAt: string;

  /**
   * names of sources that failed this assembly
   *
   * @generated from field: repeated string stale_sources = 9;
   */
  staleSources: string[];
};

/**
 * Describes the message memba.v1.HomeSnapshot.
 * Use `create(HomeSnapshotSchema)` to create a new message.
 */
export const HomeSnapshotSchema: GenMessage<HomeSnapshot> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 99);

/**
 * @generated from message memba.v1.GetHomeSnapshotRequest
 */
export type GetHomeSnapshotRequest = Message<"memba.v1.GetHomeSnapshotRequest"> & {
  /**
   * no auth required — public read
   *
   * @generated from field: string chain_id = 1;
   */
  chainId: string;
};

/**
 * Describes the message memba.v1.GetHomeSnapshotRequest.
 * Use `create(GetHomeSnapshotRequestSchema)` to create a new message.
 */
export const GetHomeSnapshotRequestSchema: GenMessage<GetHomeSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 100);

/**
 * @generated from message memba.v1.GetHomeSnapshotResponse
 */
export type GetHomeSnapshotResponse = Message<"memba.v1.GetHomeSnapshotResponse"> & {
  /**
   * @generated from field: memba.v1.HomeSnapshot snapshot = 1;
   */
  snapshot?: HomeSnapshot | undefined;
};

/**
 * Describes the message memba.v1.GetHomeSnapshotResponse.
 * Use `create(GetHomeSnapshotResponseSchema)` to create a new message.
 */
export const GetHomeSnapshotResponseSchema: GenMessage<GetHomeSnapshotResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 101);

/**
 * FeedPost is one post's indexed projection (from the memba_feed_v1 realm).
 * Hidden/deleted posts are omitted from timeline reads; a thread read may
 * include a deleted PARENT as a tombstone so replies keep their context.
 *
 * @generated from message memba.v1.FeedPost
 */
export type FeedPost = Message<"memba.v1.FeedPost"> & {
  /**
   * realm post id (monotonic)
   *
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * g1... address
   *
   * @generated from field: string author = 2;
   */
  author: string;

  /**
   * empty when deleted
   *
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * 0 = top-level
   *
   * @generated from field: uint64 reply_to = 4;
   */
  replyTo: bigint;

  /**
   * block height the post was created at
   *
   * @generated from field: int64 block_h = 6;
   */
  blockH: bigint;

  /**
   * block height of last edit, 0 = never
   *
   * @generated from field: int64 edited_at = 7;
   */
  editedAt: bigint;

  /**
   * @generated from field: uint32 flag_count = 8;
   */
  flagCount: number;

  /**
   * @generated from field: bool hidden = 9;
   */
  hidden: boolean;

  /**
   * @generated from field: bool deleted = 10;
   */
  deleted: boolean;

  /**
   * live replies indexed under this post
   *
   * @generated from field: uint32 reply_count = 11;
   */
  replyCount: number;

  /**
   * block header time (unix seconds); 0 = unknown. The
   *
   * @generated from field: int64 block_ts = 12;
   */
  blockTs: bigint;

  /**
   * DETERMINISTIC display timestamp — NOT the indexer's
   * ingest wall-clock (which re-stamps on rebuild-from-raw).
   * viewer_has_flagged (feed v2 plan C.1): true when the REQUESTING viewer
   * (GetFeedTimelineRequest.viewer_address / GetFeedThreadRequest.viewer_address)
   * previously flagged this post, from the durable feed_flags projection —
   * replaces the per-mount localStorage state that forgot across reloads.
   * Always false when the request carried no viewer_address (anonymous read).
   *
   * @generated from field: bool viewer_has_flagged = 13;
   */
  viewerHasFlagged: boolean;
};

/**
 * Describes the message memba.v1.FeedPost.
 * Use `create(FeedPostSchema)` to create a new message.
 */
export const FeedPostSchema: GenMessage<FeedPost> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 102);

/**
 * @generated from message memba.v1.GetFeedTimelineRequest
 */
export type GetFeedTimelineRequest = Message<"memba.v1.GetFeedTimelineRequest"> & {
  /**
   * return posts strictly older than this id; 0 = newest
   *
   * @generated from field: uint64 cursor = 1;
   */
  cursor: bigint;

  /**
   * default 20, max 100
   *
   * @generated from field: uint32 limit = 2;
   */
  limit: number;

  /**
   * Optional (empty = anonymous). NOT auth — the address is not a secret and
   * this is a public read, same posture as GetReplyNotifications's author
   * param; it only shapes viewer_has_flagged on the returned posts.
   *
   * @generated from field: string viewer_address = 3;
   */
  viewerAddress: string;
};

/**
 * Describes the message memba.v1.GetFeedTimelineRequest.
 * Use `create(GetFeedTimelineRequestSchema)` to create a new message.
 */
export const GetFeedTimelineRequestSchema: GenMessage<GetFeedTimelineRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 103);

/**
 * @generated from message memba.v1.GetFeedTimelineResponse
 */
export type GetFeedTimelineResponse = Message<"memba.v1.GetFeedTimelineResponse"> & {
  /**
   * @generated from field: repeated memba.v1.FeedPost posts = 1;
   */
  posts: FeedPost[];

  /**
   * pass as cursor for the next page; 0 = end
   *
   * @generated from field: uint64 next_cursor = 2;
   */
  nextCursor: bigint;

  /**
   * feed indexer cursor (staleness signal)
   *
   * @generated from field: int64 indexer_last_block = 3;
   */
  indexerLastBlock: bigint;
};

/**
 * Describes the message memba.v1.GetFeedTimelineResponse.
 * Use `create(GetFeedTimelineResponseSchema)` to create a new message.
 */
export const GetFeedTimelineResponseSchema: GenMessage<GetFeedTimelineResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 104);

/**
 * @generated from message memba.v1.GetUserFeedRequest
 */
export type GetUserFeedRequest = Message<"memba.v1.GetUserFeedRequest"> & {
  /**
   * g1... address
   *
   * @generated from field: string author = 1;
   */
  author: string;

  /**
   * @generated from field: uint64 cursor = 2;
   */
  cursor: bigint;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetUserFeedRequest.
 * Use `create(GetUserFeedRequestSchema)` to create a new message.
 */
export const GetUserFeedRequestSchema: GenMessage<GetUserFeedRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 105);

/**
 * @generated from message memba.v1.GetUserFeedResponse
 */
export type GetUserFeedResponse = Message<"memba.v1.GetUserFeedResponse"> & {
  /**
   * @generated from field: repeated memba.v1.FeedPost posts = 1;
   */
  posts: FeedPost[];

  /**
   * @generated from field: uint64 next_cursor = 2;
   */
  nextCursor: bigint;
};

/**
 * Describes the message memba.v1.GetUserFeedResponse.
 * Use `create(GetUserFeedResponseSchema)` to create a new message.
 */
export const GetUserFeedResponseSchema: GenMessage<GetUserFeedResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 106);

/**
 * @generated from message memba.v1.GetFeedThreadRequest
 */
export type GetFeedThreadRequest = Message<"memba.v1.GetFeedThreadRequest"> & {
  /**
   * the root/parent post
   *
   * @generated from field: uint64 post_id = 1;
   */
  postId: bigint;

  /**
   * replies strictly after this id; 0 = from the start
   *
   * @generated from field: uint64 cursor = 2;
   */
  cursor: bigint;

  /**
   * @generated from field: uint32 limit = 3;
   */
  limit: number;

  /**
   * Optional (empty = anonymous) — see GetFeedTimelineRequest.viewer_address.
   *
   * @generated from field: string viewer_address = 4;
   */
  viewerAddress: string;
};

/**
 * Describes the message memba.v1.GetFeedThreadRequest.
 * Use `create(GetFeedThreadRequestSchema)` to create a new message.
 */
export const GetFeedThreadRequestSchema: GenMessage<GetFeedThreadRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 107);

/**
 * @generated from message memba.v1.GetFeedThreadResponse
 */
export type GetFeedThreadResponse = Message<"memba.v1.GetFeedThreadResponse"> & {
  /**
   * the parent (may be a deleted tombstone)
   *
   * @generated from field: memba.v1.FeedPost root = 1;
   */
  root?: FeedPost | undefined;

  /**
   * oldest-first (conversation order)
   *
   * @generated from field: repeated memba.v1.FeedPost replies = 2;
   */
  replies: FeedPost[];

  /**
   * @generated from field: uint64 next_cursor = 3;
   */
  nextCursor: bigint;
};

/**
 * Describes the message memba.v1.GetFeedThreadResponse.
 * Use `create(GetFeedThreadResponseSchema)` to create a new message.
 */
export const GetFeedThreadResponseSchema: GenMessage<GetFeedThreadResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 108);

/**
 * @generated from message memba.v1.GetDailyChallengeRequest
 */
export type GetDailyChallengeRequest = Message<"memba.v1.GetDailyChallengeRequest"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;
};

/**
 * Describes the message memba.v1.GetDailyChallengeRequest.
 * Use `create(GetDailyChallengeRequestSchema)` to create a new message.
 */
export const GetDailyChallengeRequestSchema: GenMessage<GetDailyChallengeRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 109);

/**
 * @generated from message memba.v1.GetDailyChallengeResponse
 */
export type GetDailyChallengeResponse = Message<"memba.v1.GetDailyChallengeResponse"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: uint32 seed = 2;
   */
  seed: number;

  /**
   * @generated from field: int64 block_height = 3;
   */
  blockHeight: bigint;

  /**
   * @generated from field: string block_hash = 4;
   */
  blockHash: string;

  /**
   * @generated from field: string modifier = 5;
   */
  modifier: string;

  /**
   * @generated from field: int64 par = 6;
   */
  par: bigint;

  /**
   * false when the day's block isn't mined yet
   *
   * @generated from field: bool ready = 7;
   */
  ready: boolean;

  /**
   * @generated from field: int32 move_budget = 8;
   */
  moveBudget: number;
};

/**
 * Describes the message memba.v1.GetDailyChallengeResponse.
 * Use `create(GetDailyChallengeResponseSchema)` to create a new message.
 */
export const GetDailyChallengeResponseSchema: GenMessage<GetDailyChallengeResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 110);

/**
 * @generated from message memba.v1.SubmitScoreRequest
 */
export type SubmitScoreRequest = Message<"memba.v1.SubmitScoreRequest"> & {
  /**
   * reuse existing Token message
   *
   * @generated from field: memba.v1.Token auth_token = 1;
   */
  authToken?: Token | undefined;

  /**
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * compact moves, e.g. "URDL..."
   *
   * @generated from field: string move_log = 3;
   */
  moveLog: string;
};

/**
 * Describes the message memba.v1.SubmitScoreRequest.
 * Use `create(SubmitScoreRequestSchema)` to create a new message.
 */
export const SubmitScoreRequestSchema: GenMessage<SubmitScoreRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 111);

/**
 * @generated from message memba.v1.SubmitScoreResponse
 */
export type SubmitScoreResponse = Message<"memba.v1.SubmitScoreResponse"> & {
  /**
   * authoritative = server replay
   *
   * @generated from field: int64 score = 1;
   */
  score: bigint;

  /**
   * % of today's field beaten
   *
   * @generated from field: int32 percentile = 2;
   */
  percentile: number;

  /**
   * @generated from field: int64 par = 3;
   */
  par: bigint;

  /**
   * @generated from field: memba.v1.BlockPartyStreak streak = 4;
   */
  streak?: BlockPartyStreak | undefined;
};

/**
 * Describes the message memba.v1.SubmitScoreResponse.
 * Use `create(SubmitScoreResponseSchema)` to create a new message.
 */
export const SubmitScoreResponseSchema: GenMessage<SubmitScoreResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 112);

/**
 * @generated from message memba.v1.BlockPartyStreak
 */
export type BlockPartyStreak = Message<"memba.v1.BlockPartyStreak"> & {
  /**
   * @generated from field: int32 current = 1;
   */
  current: number;

  /**
   * @generated from field: int32 longest = 2;
   */
  longest: number;

  /**
   * @generated from field: int32 freezes_remaining = 3;
   */
  freezesRemaining: number;
};

/**
 * Describes the message memba.v1.BlockPartyStreak.
 * Use `create(BlockPartyStreakSchema)` to create a new message.
 */
export const BlockPartyStreakSchema: GenMessage<BlockPartyStreak> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 113);

/**
 * @generated from message memba.v1.GetDailyLeaderboardRequest
 */
export type GetDailyLeaderboardRequest = Message<"memba.v1.GetDailyLeaderboardRequest"> & {
  /**
   * @generated from field: string date = 1;
   */
  date: string;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetDailyLeaderboardRequest.
 * Use `create(GetDailyLeaderboardRequestSchema)` to create a new message.
 */
export const GetDailyLeaderboardRequestSchema: GenMessage<GetDailyLeaderboardRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 114);

/**
 * @generated from message memba.v1.LeaderboardScore
 */
export type LeaderboardScore = Message<"memba.v1.LeaderboardScore"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;

  /**
   * @generated from field: int64 score = 2;
   */
  score: bigint;

  /**
   * @generated from field: int32 rank = 3;
   */
  rank: number;
};

/**
 * Describes the message memba.v1.LeaderboardScore.
 * Use `create(LeaderboardScoreSchema)` to create a new message.
 */
export const LeaderboardScoreSchema: GenMessage<LeaderboardScore> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 115);

/**
 * @generated from message memba.v1.GetDailyLeaderboardResponse
 */
export type GetDailyLeaderboardResponse = Message<"memba.v1.GetDailyLeaderboardResponse"> & {
  /**
   * @generated from field: repeated memba.v1.LeaderboardScore entries = 1;
   */
  entries: LeaderboardScore[];
};

/**
 * Describes the message memba.v1.GetDailyLeaderboardResponse.
 * Use `create(GetDailyLeaderboardResponseSchema)` to create a new message.
 */
export const GetDailyLeaderboardResponseSchema: GenMessage<GetDailyLeaderboardResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 116);

/**
 * @generated from message memba.v1.GetStreakRequest
 */
export type GetStreakRequest = Message<"memba.v1.GetStreakRequest"> & {
  /**
   * @generated from field: string address = 1;
   */
  address: string;
};

/**
 * Describes the message memba.v1.GetStreakRequest.
 * Use `create(GetStreakRequestSchema)` to create a new message.
 */
export const GetStreakRequestSchema: GenMessage<GetStreakRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 117);

/**
 * @generated from message memba.v1.GetStreakResponse
 */
export type GetStreakResponse = Message<"memba.v1.GetStreakResponse"> & {
  /**
   * @generated from field: memba.v1.BlockPartyStreak streak = 1;
   */
  streak?: BlockPartyStreak | undefined;
};

/**
 * Describes the message memba.v1.GetStreakResponse.
 * Use `create(GetStreakResponseSchema)` to create a new message.
 */
export const GetStreakResponseSchema: GenMessage<GetStreakResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 118);

/**
 * @generated from message memba.v1.GetReplyNotificationsRequest
 */
export type GetReplyNotificationsRequest = Message<"memba.v1.GetReplyNotificationsRequest"> & {
  /**
   * the caller — whose posts' replies we want
   *
   * @generated from field: string author = 1;
   */
  author: string;

  /**
   * unread = replies with id > this (the client's last-seen)
   *
   * @generated from field: uint64 since_id = 2;
   */
  sinceId: bigint;

  /**
   * default 20, max 100
   *
   * @generated from field: uint32 limit = 3;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetReplyNotificationsRequest.
 * Use `create(GetReplyNotificationsRequestSchema)` to create a new message.
 */
export const GetReplyNotificationsRequestSchema: GenMessage<GetReplyNotificationsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 119);

/**
 * @generated from message memba.v1.GetReplyNotificationsResponse
 */
export type GetReplyNotificationsResponse = Message<"memba.v1.GetReplyNotificationsResponse"> & {
  /**
   * Live replies to the author's posts, by other people, newest-first.
   *
   * @generated from field: repeated memba.v1.FeedPost replies = 1;
   */
  replies: FeedPost[];

  /**
   * how many replies have id > since_id
   *
   * @generated from field: uint32 unread_count = 2;
   */
  unreadCount: number;

  /**
   * newest reply id (0 = none) — advance the cursor to this
   *
   * @generated from field: uint64 latest_id = 3;
   */
  latestId: bigint;
};

/**
 * Describes the message memba.v1.GetReplyNotificationsResponse.
 * Use `create(GetReplyNotificationsResponseSchema)` to create a new message.
 */
export const GetReplyNotificationsResponseSchema: GenMessage<GetReplyNotificationsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 120);

/**
 * @generated from message memba.v1.GetFeedStatsRequest
 */
export type GetFeedStatsRequest = Message<"memba.v1.GetFeedStatsRequest"> & {
};

/**
 * Describes the message memba.v1.GetFeedStatsRequest.
 * Use `create(GetFeedStatsRequestSchema)` to create a new message.
 */
export const GetFeedStatsRequestSchema: GenMessage<GetFeedStatsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 121);

/**
 * @generated from message memba.v1.GetFeedStatsResponse
 */
export type GetFeedStatsResponse = Message<"memba.v1.GetFeedStatsResponse"> & {
  /**
   * visible top-level posts
   *
   * @generated from field: uint64 live_posts = 1;
   */
  livePosts: bigint;

  /**
   * visible replies
   *
   * @generated from field: uint64 total_replies = 2;
   */
  totalReplies: bigint;

  /**
   * distinct authors of visible posts
   *
   * @generated from field: uint64 total_authors = 3;
   */
  totalAuthors: bigint;

  /**
   * Most-replied visible top-level posts, reply-count-descending (trending).
   *
   * @generated from field: repeated memba.v1.FeedPost most_replied = 4;
   */
  mostReplied: FeedPost[];
};

/**
 * Describes the message memba.v1.GetFeedStatsResponse.
 * Use `create(GetFeedStatsResponseSchema)` to create a new message.
 */
export const GetFeedStatsResponseSchema: GenMessage<GetFeedStatsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 122);

/**
 * @generated from message memba.v1.GetModerationLogRequest
 */
export type GetModerationLogRequest = Message<"memba.v1.GetModerationLogRequest"> & {
  /**
   * return entries strictly older than this seq; 0 = newest
   *
   * @generated from field: uint64 cursor = 1;
   */
  cursor: bigint;

  /**
   * default 20, max 100
   *
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetModerationLogRequest.
 * Use `create(GetModerationLogRequestSchema)` to create a new message.
 */
export const GetModerationLogRequestSchema: GenMessage<GetModerationLogRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 123);

/**
 * One moderation event — BODY-FREE by construction (ids + reasons only). Sourced
 * from the immutable raw ledger (PostFlagged / PostAutoHidden / ModAction), so a
 * takedown's reason is auditable without re-exposing the offending content.
 *
 * @generated from message memba.v1.ModerationLogEntry
 */
export type ModerationLogEntry = Message<"memba.v1.ModerationLogEntry"> & {
  /**
   * opaque monotonic cursor (newest = highest)
   *
   * @generated from field: uint64 seq = 1;
   */
  seq: bigint;

  /**
   * @generated from field: uint64 post_id = 2;
   */
  postId: bigint;

  /**
   * "flagged" | "auto_hidden" | "mod_removed" | "mod_unhidden"
   *
   * @generated from field: string action = 3;
   */
  action: string;

  /**
   * flagger / moderator address; "" when the event carries none
   *
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * event block height
   *
   * @generated from field: int64 block_h = 5;
   */
  blockH: bigint;
};

/**
 * Describes the message memba.v1.ModerationLogEntry.
 * Use `create(ModerationLogEntrySchema)` to create a new message.
 */
export const ModerationLogEntrySchema: GenMessage<ModerationLogEntry> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 124);

/**
 * @generated from message memba.v1.GetModerationLogResponse
 */
export type GetModerationLogResponse = Message<"memba.v1.GetModerationLogResponse"> & {
  /**
   * @generated from field: repeated memba.v1.ModerationLogEntry entries = 1;
   */
  entries: ModerationLogEntry[];

  /**
   * pass as cursor for the next page; 0 = end
   *
   * @generated from field: uint64 next_cursor = 2;
   */
  nextCursor: bigint;
};

/**
 * Describes the message memba.v1.GetModerationLogResponse.
 * Use `create(GetModerationLogResponseSchema)` to create a new message.
 */
export const GetModerationLogResponseSchema: GenMessage<GetModerationLogResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 125);

/**
 * @generated from message memba.v1.GetFlaggedPostsRequest
 */
export type GetFlaggedPostsRequest = Message<"memba.v1.GetFlaggedPostsRequest"> & {
  /**
   * return posts strictly older than this id; 0 = newest
   *
   * @generated from field: uint64 cursor = 1;
   */
  cursor: bigint;

  /**
   * default 20, max 100
   *
   * @generated from field: uint32 limit = 2;
   */
  limit: number;
};

/**
 * Describes the message memba.v1.GetFlaggedPostsRequest.
 * Use `create(GetFlaggedPostsRequestSchema)` to create a new message.
 */
export const GetFlaggedPostsRequestSchema: GenMessage<GetFlaggedPostsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 126);

/**
 * @generated from message memba.v1.GetFlaggedPostsResponse
 */
export type GetFlaggedPostsResponse = Message<"memba.v1.GetFlaggedPostsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.FeedPost posts = 1;
   */
  posts: FeedPost[];

  /**
   * pass as cursor for the next page; 0 = end
   *
   * @generated from field: uint64 next_cursor = 2;
   */
  nextCursor: bigint;
};

/**
 * Describes the message memba.v1.GetFlaggedPostsResponse.
 * Use `create(GetFlaggedPostsResponseSchema)` to create a new message.
 */
export const GetFlaggedPostsResponseSchema: GenMessage<GetFlaggedPostsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 127);

/**
 * @generated from message memba.v1.GetLinkPreviewRequest
 */
export type GetLinkPreviewRequest = Message<"memba.v1.GetLinkPreviewRequest"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;
};

/**
 * Describes the message memba.v1.GetLinkPreviewRequest.
 * Use `create(GetLinkPreviewRequestSchema)` to create a new message.
 */
export const GetLinkPreviewRequestSchema: GenMessage<GetLinkPreviewRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 128);

/**
 * @generated from message memba.v1.GetLinkPreviewResponse
 */
export type GetLinkPreviewResponse = Message<"memba.v1.GetLinkPreviewResponse"> & {
  /**
   * false → render the plain link card (unknown / blocked / disabled)
   *
   * @generated from field: bool ok = 1;
   */
  ok: boolean;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: string site_name = 4;
   */
  siteName: string;

  /**
   * resolved/canonical URL (post-redirect)
   *
   * @generated from field: string canonical_url = 5;
   */
  canonicalUrl: string;

  /**
   * opaque signed token for GET /api/link-image; "" if none
   *
   * @generated from field: string image_token = 6;
   */
  imageToken: string;

  /**
   * og:image:width if present (aspect ratio; 0 = unknown)
   *
   * @generated from field: int32 image_width = 7;
   */
  imageWidth: number;

  /**
   * og:image:height if present (0 = unknown)
   *
   * @generated from field: int32 image_height = 8;
   */
  imageHeight: number;
};

/**
 * Describes the message memba.v1.GetLinkPreviewResponse.
 * Use `create(GetLinkPreviewResponseSchema)` to create a new message.
 */
export const GetLinkPreviewResponseSchema: GenMessage<GetLinkPreviewResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 129);

/**
 * @generated from message memba.v1.GetPostReactionsRequest
 */
export type GetPostReactionsRequest = Message<"memba.v1.GetPostReactionsRequest"> & {
  /**
   * @generated from field: repeated uint64 post_ids = 1;
   */
  postIds: bigint[];

  /**
   * optional; marks which emojis this wallet reacted with
   *
   * @generated from field: string viewer = 2;
   */
  viewer: string;
};

/**
 * Describes the message memba.v1.GetPostReactionsRequest.
 * Use `create(GetPostReactionsRequestSchema)` to create a new message.
 */
export const GetPostReactionsRequestSchema: GenMessage<GetPostReactionsRequest> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 130);

/**
 * @generated from message memba.v1.EmojiCount
 */
export type EmojiCount = Message<"memba.v1.EmojiCount"> & {
  /**
   * @generated from field: string emoji = 1;
   */
  emoji: string;

  /**
   * @generated from field: uint64 count = 2;
   */
  count: bigint;

  /**
   * true when the request's viewer reacted with this emoji
   *
   * @generated from field: bool viewer_reacted = 3;
   */
  viewerReacted: boolean;
};

/**
 * Describes the message memba.v1.EmojiCount.
 * Use `create(EmojiCountSchema)` to create a new message.
 */
export const EmojiCountSchema: GenMessage<EmojiCount> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 131);

/**
 * @generated from message memba.v1.PostReactions
 */
export type PostReactions = Message<"memba.v1.PostReactions"> & {
  /**
   * @generated from field: uint64 post_id = 1;
   */
  postId: bigint;

  /**
   * count-descending
   *
   * @generated from field: repeated memba.v1.EmojiCount reactions = 2;
   */
  reactions: EmojiCount[];
};

/**
 * Describes the message memba.v1.PostReactions.
 * Use `create(PostReactionsSchema)` to create a new message.
 */
export const PostReactionsSchema: GenMessage<PostReactions> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 132);

/**
 * @generated from message memba.v1.GetPostReactionsResponse
 */
export type GetPostReactionsResponse = Message<"memba.v1.GetPostReactionsResponse"> & {
  /**
   * @generated from field: repeated memba.v1.PostReactions posts = 1;
   */
  posts: PostReactions[];
};

/**
 * Describes the message memba.v1.GetPostReactionsResponse.
 * Use `create(GetPostReactionsResponseSchema)` to create a new message.
 */
export const GetPostReactionsResponseSchema: GenMessage<GetPostReactionsResponse> = /*@__PURE__*/
  messageDesc(file_memba_v1_memba, 133);

/**
 * @generated from enum memba.v1.JoinState
 */
export enum JoinState {
  /**
   * @generated from enum value: JOIN_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: JOIN_STATE_IN = 1;
   */
  IN = 1,

  /**
   * @generated from enum value: JOIN_STATE_OUT = 2;
   */
  OUT = 2,
}

/**
 * Describes the enum memba.v1.JoinState.
 */
export const JoinStateSchema: GenEnum<JoinState> = /*@__PURE__*/
  enumDesc(file_memba_v1_memba, 0);

/**
 * @generated from enum memba.v1.ExecutionState
 */
export enum ExecutionState {
  /**
   * @generated from enum value: EXECUTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXECUTION_STATE_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: EXECUTION_STATE_EXECUTED = 2;
   */
  EXECUTED = 2,
}

/**
 * Describes the enum memba.v1.ExecutionState.
 */
export const ExecutionStateSchema: GenEnum<ExecutionState> = /*@__PURE__*/
  enumDesc(file_memba_v1_memba, 1);

/**
 * @generated from enum memba.v1.TeamRole
 */
export enum TeamRole {
  /**
   * @generated from enum value: TEAM_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TEAM_ROLE_MEMBER = 1;
   */
  MEMBER = 1,

  /**
   * @generated from enum value: TEAM_ROLE_ADMIN = 2;
   */
  ADMIN = 2,
}

/**
 * Describes the enum memba.v1.TeamRole.
 */
export const TeamRoleSchema: GenEnum<TeamRole> = /*@__PURE__*/
  enumDesc(file_memba_v1_memba, 2);

/**
 * MultisigService provides multisig wallet management and transaction coordination.
 *
 * @generated from service memba.v1.MultisigService
 */
export const MultisigService: GenService<{
  /**
   * Auth — Challenge-response authentication (ed25519)
   *
   * @generated from rpc memba.v1.MultisigService.GetChallenge
   */
  getChallenge: {
    methodKind: "unary";
    input: typeof GetChallengeRequestSchema;
    output: typeof GetChallengeResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetToken
   */
  getToken: {
    methodKind: "unary";
    input: typeof GetTokenRequestSchema;
    output: typeof GetTokenResponseSchema;
  },
  /**
   * Multisig — CRUD
   *
   * @generated from rpc memba.v1.MultisigService.CreateOrJoinMultisig
   */
  createOrJoinMultisig: {
    methodKind: "unary";
    input: typeof CreateOrJoinMultisigRequestSchema;
    output: typeof CreateOrJoinMultisigResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.MultisigInfo
   */
  multisigInfo: {
    methodKind: "unary";
    input: typeof MultisigInfoRequestSchema;
    output: typeof MultisigInfoResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.Multisigs
   */
  multisigs: {
    methodKind: "unary";
    input: typeof MultisigsRequestSchema;
    output: typeof MultisigsResponseSchema;
  },
  /**
   * Transactions — Propose, sign, complete
   *
   * @generated from rpc memba.v1.MultisigService.CreateTransaction
   */
  createTransaction: {
    methodKind: "unary";
    input: typeof CreateTransactionRequestSchema;
    output: typeof CreateTransactionResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetTransaction
   */
  getTransaction: {
    methodKind: "unary";
    input: typeof GetTransactionRequestSchema;
    output: typeof GetTransactionResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.Transactions
   */
  transactions: {
    methodKind: "unary";
    input: typeof TransactionsRequestSchema;
    output: typeof TransactionsResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.SignTransaction
   */
  signTransaction: {
    methodKind: "unary";
    input: typeof SignTransactionRequestSchema;
    output: typeof SignTransactionResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.CompleteTransaction
   */
  completeTransaction: {
    methodKind: "unary";
    input: typeof CompleteTransactionRequestSchema;
    output: typeof CompleteTransactionResponseSchema;
  },
  /**
   * Profile — Read/Write user profile
   *
   * @generated from rpc memba.v1.MultisigService.GetProfile
   */
  getProfile: {
    methodKind: "unary";
    input: typeof GetProfileRequestSchema;
    output: typeof GetProfileResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.UpdateProfile
   */
  updateProfile: {
    methodKind: "unary";
    input: typeof UpdateProfileRequestSchema;
    output: typeof UpdateProfileResponseSchema;
  },
  /**
   * Quests — GnoBuilders quest system (85 quests, ranks, badges)
   *
   * @generated from rpc memba.v1.MultisigService.CompleteQuest
   */
  completeQuest: {
    methodKind: "unary";
    input: typeof CompleteQuestRequestSchema;
    output: typeof CompleteQuestResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetUserQuests
   */
  getUserQuests: {
    methodKind: "unary";
    input: typeof GetUserQuestsRequestSchema;
    output: typeof GetUserQuestsResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.SyncQuests
   */
  syncQuests: {
    methodKind: "unary";
    input: typeof SyncQuestsRequestSchema;
    output: typeof SyncQuestsResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetUserRank
   */
  getUserRank: {
    methodKind: "unary";
    input: typeof GetUserRankRequestSchema;
    output: typeof GetUserRankResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetLeaderboard
   */
  getLeaderboard: {
    methodKind: "unary";
    input: typeof GetLeaderboardRequestSchema;
    output: typeof GetLeaderboardResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.SubmitQuestClaim
   */
  submitQuestClaim: {
    methodKind: "unary";
    input: typeof SubmitQuestClaimRequestSchema;
    output: typeof SubmitQuestClaimResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.ReviewQuestClaim
   */
  reviewQuestClaim: {
    methodKind: "unary";
    input: typeof ReviewQuestClaimRequestSchema;
    output: typeof ReviewQuestClaimResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.ListPendingClaims
   */
  listPendingClaims: {
    methodKind: "unary";
    input: typeof ListPendingClaimsRequestSchema;
    output: typeof ListPendingClaimsResponseSchema;
  },
  /**
   * On-chain attestation (Q-05): backend-signed vouchers a user broadcasts to
   * the memba_quest_attestation_v1 realm. Public read; empty when the backend
   * attestation signer is not configured.
   *
   * @generated from rpc memba.v1.MultisigService.GetAttestationVouchers
   */
  getAttestationVouchers: {
    methodKind: "unary";
    input: typeof GetAttestationVouchersRequestSchema;
    output: typeof GetAttestationVouchersResponseSchema;
  },
  /**
   * Teams — Collaborative workspaces for DAO management
   *
   * @generated from rpc memba.v1.MultisigService.CreateTeam
   */
  createTeam: {
    methodKind: "unary";
    input: typeof CreateTeamRequestSchema;
    output: typeof CreateTeamResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetTeam
   */
  getTeam: {
    methodKind: "unary";
    input: typeof GetTeamRequestSchema;
    output: typeof GetTeamResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetMyTeams
   */
  getMyTeams: {
    methodKind: "unary";
    input: typeof GetMyTeamsRequestSchema;
    output: typeof GetMyTeamsResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.JoinTeam
   */
  joinTeam: {
    methodKind: "unary";
    input: typeof JoinTeamRequestSchema;
    output: typeof JoinTeamResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.LeaveTeam
   */
  leaveTeam: {
    methodKind: "unary";
    input: typeof LeaveTeamRequestSchema;
    output: typeof LeaveTeamResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.UpdateTeamMemberRole
   */
  updateTeamMemberRole: {
    methodKind: "unary";
    input: typeof UpdateTeamMemberRoleRequestSchema;
    output: typeof UpdateTeamMemberRoleResponseSchema;
  },
  /**
   * Marketplace — Agent favorites and stats
   *
   * @generated from rpc memba.v1.MultisigService.FavoriteAgent
   */
  favoriteAgent: {
    methodKind: "unary";
    input: typeof FavoriteAgentRequestSchema;
    output: typeof FavoriteAgentResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetFavorites
   */
  getFavorites: {
    methodKind: "unary";
    input: typeof GetFavoritesRequestSchema;
    output: typeof GetFavoritesResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetAgentStats
   */
  getAgentStats: {
    methodKind: "unary";
    input: typeof GetAgentStatsRequestSchema;
    output: typeof GetAgentStatsResponseSchema;
  },
  /**
   * Services — Freelance service listings
   *
   * @generated from rpc memba.v1.MultisigService.CreateServiceListing
   */
  createServiceListing: {
    methodKind: "unary";
    input: typeof CreateServiceListingRequestSchema;
    output: typeof CreateServiceListingResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetServiceListings
   */
  getServiceListings: {
    methodKind: "unary";
    input: typeof GetServiceListingsRequestSchema;
    output: typeof GetServiceListingsResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.UpdateServiceListing
   */
  updateServiceListing: {
    methodKind: "unary";
    input: typeof UpdateServiceListingRequestSchema;
    output: typeof UpdateServiceListingResponseSchema;
  },
  /**
   * NFT Marketplace — cached state from the on-chain indexer (public reads, no auth)
   *
   * @generated from rpc memba.v1.MultisigService.GetNFTCollection
   */
  getNFTCollection: {
    methodKind: "unary";
    input: typeof GetNFTCollectionRequestSchema;
    output: typeof GetNFTCollectionResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetNFTActivity
   */
  getNFTActivity: {
    methodKind: "unary";
    input: typeof GetNFTActivityRequestSchema;
    output: typeof GetNFTActivityResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetNFTPortfolio
   */
  getNFTPortfolio: {
    methodKind: "unary";
    input: typeof GetNFTPortfolioRequestSchema;
    output: typeof GetNFTPortfolioResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.ListNFTTokens
   */
  listNFTTokens: {
    methodKind: "unary";
    input: typeof ListNFTTokensRequestSchema;
    output: typeof ListNFTTokensResponseSchema;
  },
  /**
   * Home — aggregated dashboard snapshot (public read, server-cached)
   *
   * @generated from rpc memba.v1.MultisigService.GetHomeSnapshot
   */
  getHomeSnapshot: {
    methodKind: "unary";
    input: typeof GetHomeSnapshotRequestSchema;
    output: typeof GetHomeSnapshotResponseSchema;
  },
  /**
   * Social feed — cached timelines from the memba_feed_v1 indexer (public
   * reads, no auth). The realm is the source of truth; these serve the
   * indexed projection for low-latency, optimistic-UI reads.
   *
   * @generated from rpc memba.v1.MultisigService.GetFeedTimeline
   */
  getFeedTimeline: {
    methodKind: "unary";
    input: typeof GetFeedTimelineRequestSchema;
    output: typeof GetFeedTimelineResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetUserFeed
   */
  getUserFeed: {
    methodKind: "unary";
    input: typeof GetUserFeedRequestSchema;
    output: typeof GetUserFeedResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetFeedThread
   */
  getFeedThread: {
    methodKind: "unary";
    input: typeof GetFeedThreadRequestSchema;
    output: typeof GetFeedThreadResponseSchema;
  },
  /**
   * Block Party — daily on-chain-seeded puzzle game
   *
   * @generated from rpc memba.v1.MultisigService.GetDailyChallenge
   */
  getDailyChallenge: {
    methodKind: "unary";
    input: typeof GetDailyChallengeRequestSchema;
    output: typeof GetDailyChallengeResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.SubmitScore
   */
  submitScore: {
    methodKind: "unary";
    input: typeof SubmitScoreRequestSchema;
    output: typeof SubmitScoreResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetDailyLeaderboard
   */
  getDailyLeaderboard: {
    methodKind: "unary";
    input: typeof GetDailyLeaderboardRequestSchema;
    output: typeof GetDailyLeaderboardResponseSchema;
  },
  /**
   * @generated from rpc memba.v1.MultisigService.GetStreak
   */
  getStreak: {
    methodKind: "unary";
    input: typeof GetStreakRequestSchema;
    output: typeof GetStreakResponseSchema;
  },
  /**
   * Replies to the caller's own posts — the "someone replied to you" surface.
   *
   * @generated from rpc memba.v1.MultisigService.GetReplyNotifications
   */
  getReplyNotifications: {
    methodKind: "unary";
    input: typeof GetReplyNotificationsRequestSchema;
    output: typeof GetReplyNotificationsResponseSchema;
  },
  /**
   * Feed-wide live stats for the header/rail (post + author counts).
   *
   * @generated from rpc memba.v1.MultisigService.GetFeedStats
   */
  getFeedStats: {
    methodKind: "unary";
    input: typeof GetFeedStatsRequestSchema;
    output: typeof GetFeedStatsResponseSchema;
  },
  /**
   * Public, BODY-FREE moderation transparency log (feed v2 plan C.3): the
   * on-chain moderation events (flags / auto-hides / mod actions) as ids +
   * reasons only, never post bodies. Backs the public transparency view and the
   * console's audit tab. Sourced from the immutable raw ledger.
   *
   * @generated from rpc memba.v1.MultisigService.GetModerationLog
   */
  getModerationLog: {
    methodKind: "unary";
    input: typeof GetModerationLogRequestSchema;
    output: typeof GetModerationLogResponseSchema;
  },
  /**
   * Flagged/hidden post QUEUE for the moderation console (feed v2 plan C.3) —
   * unlike GetModerationLog this carries full post bodies (a moderator must be
   * able to read what was flagged), so it is Authorization: Bearer
   * <FEED_MODERATION_BEARER>-gated and FAIL-CLOSED, same posture as
   * /api/feed/moderation: unset bearer or a mismatched/missing header both
   * reject uniformly (never distinguishes "disabled" from "wrong token").
   *
   * @generated from rpc memba.v1.MultisigService.GetFlaggedPosts
   */
  getFlaggedPosts: {
    methodKind: "unary";
    input: typeof GetFlaggedPostsRequestSchema;
    output: typeof GetFlaggedPostsResponseSchema;
  },
  /**
   * Server-side rich preview for an external URL — OG/Twitter-card metadata via
   * an SSRF-guarded fetch, with the image proxied through a signed token. Public
   * read, no auth; rate-limited; returns ok=false (never an error) so the UI can
   * fall back to a plain link card. Gated by MEMBA_ENABLE_LINK_PREVIEWS.
   *
   * @generated from rpc memba.v1.MultisigService.GetLinkPreview
   */
  getLinkPreview: {
    methodKind: "unary";
    input: typeof GetLinkPreviewRequestSchema;
    output: typeof GetLinkPreviewResponseSchema;
  },
  /**
   * Reaction counts for a set of posts (+ which emojis the viewer reacted with).
   * Public read, no auth; aggregated from the feed_reactions projection.
   *
   * @generated from rpc memba.v1.MultisigService.GetPostReactions
   */
  getPostReactions: {
    methodKind: "unary";
    input: typeof GetPostReactionsRequestSchema;
    output: typeof GetPostReactionsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_memba_v1_memba, 0);

